document.addEventListener("DOMContentLoaded", function () {
  var brandSelect = document.getElementById("filter-brand");
  var stateSelect = document.getElementById("filter-state");
  var searchButton = document.getElementById("search-button-loc");
  var table = document.getElementById("dealer-table");
  var tableBody = table.querySelector("tbody");
  var noResultsMessage = document.getElementById("no-results-message");
  var resultContainer = document.getElementById("result-container");
  var resultsText = document.getElementById("results-text");
  var resultCountElement = document.getElementById("result-count");
  var selectedBrandElement = document.getElementById("selected-brand");
  var selectedStateElement = document.getElementById("selected-state");
  var postcodeInput = document.getElementById("postcode-input");

var dealers = [
  {
    name: "Acacia Mower Centre",
    brand: "REHLKO PETROL",
    address: "Unit 4/15 Overlord Place",
    phone: "(07) 3273 6457",
    fax: "",
    service: "KP",
    suburb: "Acacia Ridge",
    state: "QLD",
    remarks: "",
    postcode: "4110",
    website: "https://mowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5955315,
    long: 153.0367448,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Adam Besedic Motorcycles",
    brand: "REHLKO PETROL",
    address: "Cnr Young Road &, Lyall St",
    phone: "(02) 6341 1951",
    fax: "",
    service: "KP",
    suburb: "Cowra",
    state: "NSW",
    remarks: "",
    postcode: "2794",
    website: "https://www.facebook.com/ABMORXP/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.8395199,
    long: 148.676539,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "ADE Turf Equipment",
    brand: "REHLKO PETROL",
    address: "17 Ashley Park Drive",
    phone: "(03) 9772 6444",
    fax: "",
    service: "KP",
    suburb: "Chelsea Heights",
    state: "VIC",
    remarks: "",
    postcode: "3196",
    website: "https://adeturf.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.0391129,
    long: 145.13888,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Admon Machinery",
    brand: "REHLKO PETROL",
    address: " 3/545 Mcdonalds Rd",
    phone: "(03) 9089 7508",
    fax: "",
    service: "KP",
    suburb: "South Morang",
    state: "VIC",
    remarks: "",
    postcode: "3752",
    website: "https://www.admonmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.651232,
    long: 145.0844008,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "AG Mowers",
    brand: "REHLKO PETROL",
    address: "77 Muldoon Street",
    phone: "(02) 6551 2995",
    fax: "",
    service: "KP",
    suburb: "Taree",
    state: "NSW",
    remarks: "",
    postcode: "2430",
    website: "https://agmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.8980292,
    long: 152.4538664,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ag Repair & Sales",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "1333 Old Northern Road",
    phone: "0422 498 906",
    fax: "",
    service: "KP|KD",
    suburb: "Middle Dural",
    state: "NSW",
    remarks: "",
    postcode: "2158",
    website: "http://www.agrepair.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -33.6327576,
    long: 151.0241328,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Agg-Tech Machinery",
    brand: "REHLKO PETROL|REHLKO DIESEL|LOMBARDINI",
    address: "41-43 Seventh St E",
    phone: "(03) 5021 2722",
    fax: "",
    service: "KP|KD|LMB",
    suburb: "Mildura",
    state: "VIC",
    remarks: "",
    postcode: "3500",
    website: "https://www.aggtech.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -34.1936622,
    long: 142.1761132,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Agies Rural",
    brand: "REHLKO PETROL",
    address: "42 Boolcarrol Road",
    phone: "(02) 6795 0500",
    fax: "",
    service: "KP",
    suburb: "Wee Waa",
    state: "NSW",
    remarks: "",
    postcode: "2388",
    website: "https://www.facebook.com/agiesrural/",
    petrol: "Yes",
    diesel: "No",
    lat: -30.2277017,
    long: 149.435709,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Agriparts & Repairs",
    brand: "REHLKO DIESEL",
    address: "29 Welshpool Road",
    phone: "(08) 9362 6811",
    fax: "",
    service: "KD",
    suburb: "Welshpool",
    state: "WA",
    remarks: "",
    postcode: "6106",
    website: "https://www.agriparts.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -31.9941428,
    long: 115.917121,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Albury Engineering & Mower Service",
    brand: "REHLKO PETROL",
    address: "208 Borella Rd",
    phone: "(02) 6041 1444",
    fax: "",
    service: "KP",
    suburb: "Albury",
    state: "NSW",
    remarks: "",
    postcode: "2640",
    website: "https://alburyengineering.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.0763173,
    long: 146.9382754,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Aldinga Mowers & Cycles",
    brand: "REHLKO PETROL",
    address: "Lot 2 Aldinga Beach Rd",
    phone: "(08) 8557 7041",
    fax: "",
    service: "KP",
    suburb: "Aldinga Beach",
    state: "SA",
    remarks: "",
    postcode: "5173",
    website: "https://amacsa.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.2780929,
    long: 35.2780929,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "All Diesel Equipment Sales",
    brand: "REHLKO DIESEL",
    address: "8 Ray Mccarthy Drive",
    phone: "(02) 6652 5121",
    fax: "",
    service: "KD",
    suburb: "Coffs Harbour",
    state: "NSW",
    remarks: "",
    postcode: "2450",
    website: "https://alldiesel.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -30.3097,
    long: 153.0999186,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Allgear Motorcycles & Small Engines",
    brand: "REHLKO PETROL",
    address: "28 Mango St",
    phone: "(08) 9169 1335",
    fax: "",
    service: "KP",
    suburb: "Kununurra",
    state: "WA",
    remarks: "",
    postcode: "6743",
    website: "https://www.facebook.com/allgearmotorcycles/",
    petrol: "Yes",
    diesel: "No",
    lat: -15.7778715,
    long: 128.7362051,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Allmake Mowers & More",
    brand: "REHLKO PETROL",
    address: "1078 South Rd",
    phone: "(08) 8271 2044",
    fax: "",
    service: "KP",
    suburb: "Edwardstown ",
    state: "SA",
    remarks: "",
    postcode: "5039",
    website: "https://allmakemowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.9895734,
    long: 138.5742375,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Alpine Mowers",
    brand: "REHLKO PETROL",
    address: "89 Main Road",
    phone: "(03) 9752 0488",
    fax: "",
    service: "KP",
    suburb: "Monbulk",
    state: "VIC",
    remarks: "",
    postcode: "3793",
    website: "https://www.facebook.com/chainsawbook/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.8727635,
    long: 145.4046302,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Appletree Mowers",
    brand: "REHLKO PETROL",
    address: "9/4 Ascot Road",
    phone: "0407 030 054",
    fax: "",
    service: "KP",
    suburb: "Ballina",
    state: "NSW",
    remarks: "",
    postcode: "2477",
    petrol: "Yes",
    diesel: "No",
    lat: -28.8486266,
    long: 153.5576102,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Arboits Farm & Machinery",
    brand: "REHLKO PETROL",
    address: "363 Beach Rd",
    phone: "(07) 4783 2792",
    fax: "",
    service: "KP",
    suburb: "Ayr",
    state: "QLD",
    remarks: "",
    postcode: "4807",
    website: "https://arboit.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -19.535136,
    long: 147.4210776,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Armadale Mower World & Service Centre",
    brand: "REHLKO PETROL",
    address: "79 Champion Drive",
    phone: "(08) 9497 1399",
    fax: "",
    service: "KP",
    suburb: "Seville Grove",
    state: "WA",
    remarks: "",
    postcode: "6112",
    website: "https://mowerworld.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.1313652,
    long: 116.0030124,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ashmore Mower Centre",
    brand: "REHLKO PETROL",
    address: "9 United Road",
    phone: "(07) 5539 4663",
    fax: "",
    service: "KP",
    suburb: "Ashmore",
    state: "QLD",
    remarks: "",
    postcode: "4216",
    website: "https://www.ashmoremower.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.9786015,
    long: 153.3834445,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "ASK Small Engines",
    brand: "REHLKO PETROL",
    address: "27 Maitland Street",
    phone: "(02) 6792 4223",
    fax: "",
    service: "KP",
    suburb: "Narrabri",
    state: "NSW",
    remarks: "",
    postcode: "2390",
    website: "https://www.facebook.com/asksmallenginerepairs/",
    petrol: "Yes",
    diesel: "No",
    lat: -30.3312139,
    long: 149.7858946,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Aussie Mower Centre",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "7 Miller Street",
    phone: "(07) 4125 3152",
    fax: "",
    service: "EFI|KP",
    suburb: "Urangan , Hervey Bay",
    state: "QLD",
    remarks: "",
    postcode: "4655",
    website: "https://aussiemowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -25.2892866,
    long: 152.8972329,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Australian Chainsaw Products",
    brand: "REHLKO PETROL",
    address: "3 Connector Park Dr",
    phone: "(03) 6343 0404",
    fax: "",
    service: "KP",
    suburb: "Kings Meadows",
    state: "TAS",
    remarks: "",
    postcode: "7249",
    website: "https://australianchainsaws.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -41.4818043,
    long: 147.1536557,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "B.W Machinery",
    brand: "REHLKO PETROL",
    address: "303 Warrigal Road",
    phone: "1300 454 585",
    fax: "",
    service: "KP",
    suburb: "Cheltenham",
    state: "VIC",
    remarks: "",
    postcode: "3192",
    website: "https://bwmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.960678,
    long: 145.0749424,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bacchus Marsh Mowers",
    brand: "REHLKO PETROL",
    address: "134 Main Street",
    phone: "(03) 5367 6699",
    fax: "",
    service: "KP",
    suburb: "Bacchus Marsh",
    state: "VIC",
    remarks: "",
    postcode: "3340",
    website: "https://www.bacchusmarshmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.6754116,
    long: 144.4369711,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ballarat Mower Centre",
    brand: "REHLKO PETROL",
    address: "822 Latrobe Street",
    phone: "(03) 5335 5986",
    fax: "",
    service: "KP",
    suburb: "Delacombe",
    state: "VIC",
    remarks: "",
    postcode: "3356",
    website: "https://ballaratmowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.571224,
    long: 143.8262412,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Barmera Small Motors",
    brand: "REHLKO PETROL",
    address: "22 Thelma Road",
    phone: "0427 360 470",
    fax: "",
    service: "KP",
    suburb: "Barmera",
    state: "SA",
    remarks: "",
    postcode: "5345",
    petrol: "Yes",
    diesel: "No",
    lat: -34.2576322,
    long: 140.4603446,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Barry Francis Motorcycles",
    brand: "REHLKO PETROL",
    address: "52 Lonsdale Street",
    phone: "(03) 5551 4999",
    fax: "",
    service: "KP",
    suburb: "Hamilton",
    state: "VIC",
    remarks: "",
    postcode: "3300",
    website: "https://barryfrancisshop.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.7429311,
    long: 142.0209623,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bathurst Mowerland & Heating",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "5 Rankin Street",
    phone: "(02) 6332 2420",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Bathurst",
    state: "NSW",
    remarks: "",
    postcode: "2795",
    website: "https://bathurstmowerland.com/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -33.4101965,
    long: 149.5833645,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "Bayside Mower & Chainsaw",
    brand: "REHLKO PETROL",
    address: "1/133 Mornington-Tyabb Road",
    phone: "(03) 5975 6060",
    fax: "",
    service: "KP",
    suburb: "Mornington",
    state: "VIC",
    remarks: "",
    postcode: "3931",
    website: "https://baysidemowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.2362103,
    long: 145.057831,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Beechworth Machinery & Mowers",
    brand: "REHLKO PETROL",
    address: "30 High Street",
    phone: "(03) 5728 2531",
    fax: "",
    service: "KP",
    suburb: "Beechworth",
    state: "VIC",
    remarks: "",
    postcode: "3747",
    website: "https://beechworthmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.3629673,
    long: 146.6847319,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Beerwah Small Engines",
    brand: "REHLKO PETROL",
    address: "7 Beerwah Pde",
    phone: "(07) 5494 6644",
    fax: "",
    service: "KP",
    suburb: "Beerwah",
    state: "QLD",
    remarks: "",
    postcode: "4519",
    petrol: "Yes",
    diesel: "No",
    lat: -26.8533363,
    long: 152.9589317,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Belconnen Outdoor Power Centre",
    brand: "REHLKO PETROL",
    address: "8/21 Rae St",
    phone: "(02) 6251 1491",
    fax: "",
    service: "KP",
    suburb: "Belconnen",
    state: "NSW",
    remarks: "",
    postcode: "2617",
    website: "http://www.bopc.net.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.2361525,
    long: 149.0613332,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Benalla Motorcycles & Power Equipment",
    brand: "REHLKO PETROL",
    address: "82 Sydney Rd",
    phone: "(03) 5762 6177",
    fax: "",
    service: "KP",
    suburb: "Benalla",
    state: "VIC",
    remarks: "",
    postcode: "3672",
    website: "https://www.benallamotorcycles.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.5458279,
    long: 146.0055691,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bendigo Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "261 High Street",
    phone: "(03) 5454 3999",
    fax: "",
    service: "KP",
    suburb: "Kangaroo Flat",
    state: "VIC",
    remarks: "",
    postcode: "3555",
    website: "http://www.bope.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.8079038,
    long: 144.241527,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Berrimah Bikes and Small Engines",
    brand: "REHLKO PETROL",
    address: "12/5 Hidden Valley Rd",
    phone: "0409 592 538",
    fax: "",
    service: "KP",
    suburb: "Berrimah",
    state: "NT",
    remarks: "",
    postcode: "0828",
    website: "https://www.facebook.com/people/Berrimah-Bikes-and-Small-Engines/61568162498647/?_rdr",
    petrol: "Yes",
    diesel: "No",
    lat: -12.4328053,
    long: 130.9173799,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bertolis Farm Machinery",
    brand: "REHLKO PETROL",
    address: "520 Dallinger Road",
    phone: "(02) 6025 5390",
    fax: "",
    service: "KP",
    suburb: "Lavington Dc",
    state: "NSW",
    remarks: "",
    postcode: "2641",
    website: "https://www.bertolis.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.0439152,
    long: 146.962795,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bevan's Small Engine Repair Centre",
    brand: "REHLKO PETROL",
    address: "16 Park Terrace",
    phone: "(07) 5482 2033",
    fax: "",
    service: "KP",
    suburb: "Gympie",
    state: "QLD",
    remarks: "",
    postcode: "4570",
    website: "https://bevanssmallengines.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.1895375,
    long: 152.6527677,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Beverly Hills Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "108 Stoney Creek Rd",
    phone: "(02) 9570 5771",
    fax: "",
    service: "KP",
    suburb: "Beverley Hills",
    state: "NSW",
    remarks: "",
    postcode: "2209",
    website: "https://beverlyhillsmowersandchainsaws.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.9549739,
    long: 151.078766,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Biloela Mechanical & Agricultural Services ",
    brand: "REHLKO PETROL",
    address: "14 Raedon St",
    phone: "(07) 4992 5332",
    fax: "",
    service: "KP",
    suburb: "Biloela",
    state: "QLD",
    remarks: "",
    postcode: "4715",
    website: "http://bmas.net.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -24.402841,
    long: 150.5072062,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Blackie's Power Equipment",
    brand: "REHLKO PETROL",
    address: "54 Yass Road",
    phone: "(02) 6942 2745",
    fax: "",
    service: "KP",
    suburb: "Cootamundra",
    state: "NSW",
    remarks: "",
    postcode: "2590",
    website: "http://blackies.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.6303816,
    long: 148.0404149,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bolton Motorcycles & Power Equipment",
    brand: "REHLKO PETROL",
    address: "10 Bourke St",
    phone: "(03) 5422 2255",
    fax: "",
    service: "KP",
    suburb: "Kyneton",
    state: "VIC",
    remarks: "",
    postcode: "3444",
    website: "https://www.boltonmotorcycles.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.2557037,
    long: 144.4656396,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bowen Small Motors & Cycles",
    brand: "REHLKO PETROL",
    address: "48 Williams Street",
    phone: "(07) 4786 4288",
    fax: "",
    service: "KP",
    suburb: "Bowen",
    state: "QLD",
    remarks: "",
    postcode: "4805",
    website: "https://www.bowensmallmotors.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -20.0143888,
    long: 148.2443093,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bowral Mowers",
    brand: "REHLKO PETROL",
    address: "250 Bong Bong St",
    phone: "(02) 4861 3487",
    fax: "",
    service: "KP",
    suburb: "Bowral",
    state: "NSW",
    remarks: "",
    postcode: "2576",
    website: "https://bowralmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.4774211,
    long: 150.4184845,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Brasch's Pty Ltd",
    brand: "REHLKO PETROL",
    address: "71 Sheridan Street",
    phone: "(07) 4051 1411",
    fax: "",
    service: "KP",
    suburb: "Cairns",
    state: "QLD",
    remarks: "",
    postcode: "4870",
    website: "https://braschs.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -16.9226233,
    long: 145.7722998,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bridge Mowers & Chainsaw Centre",
    brand: "REHLKO PETROL",
    address: "59 George St",
    phone: "(02) 4325 2107",
    fax: "",
    service: "KP",
    suburb: "East Gosford",
    state: "NSW",
    remarks: "",
    postcode: "2250",
    website: "https://bridgemowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.4392227,
    long: 151.3576523,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Browns Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "33 Piesley Street",
    phone: "(02) 6362 4933",
    fax: "",
    service: "KP",
    suburb: "Orange",
    state: "NSW",
    remarks: "",
    postcode: "2800",
    website: "http://brownsmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.2965523,
    long: 149.1006719,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Buffalo Farm Equipment",
    brand: "REHLKO PETROL",
    address: "62/66 Myrtle St",
    phone: "(03) 5752 1422",
    fax: "",
    service: "KP",
    suburb: "Myrtleford",
    state: "VIC",
    remarks: "",
    postcode: "3737",
    website: "https://www.buffalofarmequipment.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.564231,
    long: 146.728633,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bunbury Mowers",
    brand: "REHLKO PETROL",
    address: "118 Blair Street",
    phone: "(08) 9721 1626",
    fax: "",
    service: "KP",
    suburb: "Bunbury",
    state: "WA",
    remarks: "",
    postcode: "6230",
    website: "https://www.bunburymowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.3326573,
    long: 115.6430857,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Bundaberg Outdoor Power Centre",
    brand: "REHLKO PETROL",
    address: "47 Production Street",
    phone: "(07) 4152 5552",
    fax: "",
    service: "KP",
    suburb: "Bundaberg",
    state: "QLD",
    remarks: "",
    postcode: "4670",
    website: "https://www.bopc.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -24.8941311,
    long: 152.330514,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Burdekin Motorcycles",
    brand: "REHLKO PETROL",
    address: "266 Queen Street",
    phone: "(07) 4783 3773",
    fax: "",
    service: "KP",
    suburb: "Ayr",
    state: "QLD",
    remarks: "",
    postcode: "4807",
    website: "http://www.burdekinmotorcycles.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -19.5825307,
    long: 147.4001913,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Butters Warehouse",
    brand: "REHLKO PETROL",
    address: "20 Eileen Street",
    phone: "(07) 4662 2876",
    fax: "",
    service: "KP",
    suburb: "Dalby",
    state: "QLD",
    remarks: "",
    postcode: "4405",
    website: "https://www.butterswarehouse.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.1784977,
    long: 151.2694683,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cairns Mower City",
    brand: "REHLKO PETROL",
    address: "35-37 Minnie Street",
    phone: "(07) 4051 4133",
    fax: "",
    service: "KP",
    suburb: "Parramatta Park",
    state: "QLD",
    remarks: "",
    postcode: "4870",
    website: "https://www.cairnsmowercity.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -16.92141,
    long: 145.766504,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Callide Valley Mower Repairs",
    brand: "REHLKO PETROL",
    address: "2 Raedon Street",
    phone: "(07) 4992 1494",
    fax: "",
    service: "KP",
    suburb: "Biloela",
    state: "QLD",
    remarks: "",
    postcode: "4715",
    website: "https://www.cvmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -24.4025894,
    long: 150.5085788,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Calliope Rural Traders",
    brand: "REHLKO PETROL",
    address: "10 Bloom Field Street",
    phone: "(07) 4975 7475",
    fax: "",
    service: "KP",
    suburb: "Calliope",
    state: "QLD",
    remarks: "",
    postcode: "4680",
    website: "https://callioperuraltraders.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -24.0057618,
    long: 151.1996968,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Camden Machinery & Tractors",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "33 Edward Street",
    phone: "(02) 4655 9541",
    fax: "",
    service: "KP|KD",
    suburb: "Camden",
    state: "NSW",
    remarks: "",
    postcode: "2570",
    website: "https://camdenmachinery.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -34.052498,
    long: 150.6985577,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Camden Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "Unit 7/53 Cawdor Road",
    phone: "(02) 4655 6542",
    fax: "",
    service: "KP",
    suburb: "Camden",
    state: "NSW",
    remarks: "",
    postcode: "2570",
    petrol: "Yes",
    diesel: "No",
    lat: -34.0597063,
    long: 150.691922,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cameron Street Mowerworld",
    brand: "REHLKO PETROL",
    address: "Unit 1/37 Cameron Street",
    phone: "(03) 5996 5040",
    fax: "",
    service: "KP",
    suburb: "Cranbourne",
    state: "VIC",
    remarks: "",
    postcode: "3977",
    website: "https://caseymowers.com.au/#",
    petrol: "Yes",
    diesel: "No",
    lat: -38.1169683,
    long: 145.2887794,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Camperdown Mowers",
    brand: "REHLKO PETROL",
    address: "8 Pike Street",
    phone: "(03) 5593 2947",
    fax: "",
    service: "KP",
    suburb: "Camperdown",
    state: "VIC",
    remarks: "",
    postcode: "3260",
    website: "https://www.facebook.com/p/Camperdown-Mowers-100063639153842/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.2317138,
    long: 143.1481013,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Capital Tools Sales and Service",
    brand: "REHLKO PETROL",
    address: "3/52 Grimwade St",
    phone: "(02) 6170 3395",
    fax: "",
    service: "KP",
    suburb: "Mitchell",
    state: "NSW",
    remarks: "",
    postcode: "2911",
    website: "https://capital.tools/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.2176464,
    long: 149.1374937,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Carruthers Machinery",
    brand: "REHLKO PETROL",
    address: "73-77 Young Road",
    phone: "(02) 6342 4488",
    fax: "",
    service: "KP",
    suburb: "Cowra",
    state: "NSW",
    remarks: "",
    postcode: "2794",
    petrol: "Yes",
    diesel: "No",
    lat: -33.8460795,
    long: 148.6690503,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Carters Small Engine Repairs",
    brand: "REHLKO PETROL",
    address: "101-103 Main Street",
    phone: "0476 163 756",
    fax: "",
    service: "KP",
    suburb: "Minyip",
    state: "VIC",
    remarks: "",
    postcode: "3392",
    petrol: "Yes",
    diesel: "No",
    lat: -36.4587845,
    long: 142.5888925,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Casalis Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "51 Rankin Street",
    phone: "(07) 4092 3841",
    fax: "",
    service: "KP",
    suburb: "Mareeba",
    state: "QLD",
    remarks: "",
    postcode: "4880",
    website: "https://www.casalis.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -16.9973808,
    long: 145.4213136,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cattarin's Mechanical Repairs",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "2 Reeves Road",
    phone: "(07) 4681 1631",
    fax: "",
    service: "KP|KD",
    suburb: "Stanthorpe",
    state: "QLD",
    remarks: "",
    postcode: "4380",
    website: "https://cattarins.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -28.6512872,
    long: 151.9188468,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cav's Marine & Outdoor",
    brand: "REHLKO PETROL",
    address: "59504 Bruce Highway",
    phone: "(07) 4068 2222",
    fax: "",
    service: "KP",
    suburb: "Tully",
    state: "QLD",
    remarks: "",
    postcode: "4854",
    website: "https://www.cavsmarine.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -17.9269576,
    long: 145.9357222,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "CBS - Chainsaw & Brushcutter Specialists",
    brand: "REHLKO PETROL",
    address: "202 High Street",
    phone: "(02) 6585 2077",
    fax: "",
    service: "KP",
    suburb: "Wauchope",
    state: "NSW",
    remarks: "",
    postcode: "2446",
    website: "https://www.cbswauchope.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.4663878,
    long: 152.7202326,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "CD Power",
    brand: "REHLKO DIESEL",
    address: "354 Cormack Road",
    phone: "(08) 8162 7300",
    fax: "",
    service: "KD",
    suburb: "Wingfield Sa",
    state: "SA",
    remarks: "",
    postcode: "5013",
    website: "https://cdpower.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -34.8393513,
    long: 138.576113,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "Central Coast Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "205 Pacific Highway",
    phone: "(02) 4392 6766",
    fax: "",
    service: "KP",
    suburb: "Charmhaven",
    state: "NSW",
    remarks: "",
    postcode: "2263",
    website: "https://www.ccmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.2276527,
    long: 151.5034081,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Chris Proud Services",
    brand: "REHLKO PETROL",
    address: "128 Penola Road",
    phone: "(08) 8725 6616",
    fax: "",
    service: "KP",
    suburb: "Mt Gambier",
    state: "SA",
    remarks: "",
    postcode: "5290",
    website: "https://www.facebook.com/p/Chris-Proud-Services-100054217520903/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.81536,
    long: 140.7879473,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Circlesend Small Engines",
    brand: "REHLKO PETROL",
    address: "Po Box 2436",
    phone: "0410 318 366",
    fax: "",
    service: "KP",
    suburb: "Bundaberg",
    state: "QLD",
    remarks: "",
    postcode: "4670",
    website: "https://www.facebook.com/p/Circlesend-Small-Motors-100063733683136/",
    petrol: "Yes",
    diesel: "No",
    lat: -25.0379545,
    long: 152.025511,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "CJ & LH Wiesners",
    brand: "REHLKO PETROL",
    address: "77-79 Commercial Street",
    phone: "(02) 6029 2151",
    fax: "",
    service: "KP",
    suburb: "Walla Walla",
    state: "NSW",
    remarks: "",
    postcode: "2659",
    website: "https://www.wiesner.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.7665694,
    long: 146.900493,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Clayton Mower & Chainsaw Centre",
    brand: "REHLKO PETROL",
    address: "162 Rosebank Ave",
    phone: "(03) 9547 5669",
    fax: "",
    service: "KP",
    suburb: "Clayton South",
    state: "VIC",
    remarks: "",
    postcode: "3169",
    website: "https://www.facebook.com/claytonmower/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.940705,
    long: 145.139225,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Clomech Pty Ltd",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "Po Box 109",
    phone: "(08) 9572 4467",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Chidlow",
    state: "WA",
    remarks: "",
    postcode: "6556",
    website: "https://www.clomech.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -31.8625812,
    long: 116.2663028,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "Coolalinga Mowers",
    brand: "REHLKO PETROL",
    address: "14/452 Stuart Hwy",
    phone: "(08) 8983 1449",
    fax: "",
    service: "KP",
    suburb: "Coolalinga",
    state: "NT",
    remarks: "",
    postcode: "0839",
    website: "https://www.coolalingamowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -12.523916,
    long: 131.0418552,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cooma Power Equipment",
    brand: "REHLKO PETROL",
    address: "69 Commissioner Street",
    phone: "(02) 6452 2622",
    fax: "",
    service: "KP",
    suburb: "Cooma",
    state: "NSW",
    remarks: "",
    postcode: "2630",
    website: "https://www.facebook.com/coomapower/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.2348453,
    long: 149.1283188,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cooroy Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "44 Elm Street",
    phone: "(07) 5442 6333",
    fax: "",
    service: "KP",
    suburb: "Cooroy",
    state: "QLD",
    remarks: "",
    postcode: "4563",
    website: "https://cooroyoutdoorpower.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.4160054,
    long: 152.9117199,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Corinda Mower & Chainsaw Centre",
    brand: "REHLKO PETROL",
    address: "542 Sherwood Road",
    phone: "(07) 3379 6972",
    fax: "",
    service: "KP",
    suburb: "Sherwood",
    state: "QLD",
    remarks: "",
    postcode: "4075",
    website: "https://www.facebook.com/pages/Corinda%20Mower%20&%20Chain%20Saw%20Centre/902574833188483/#",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5333609,
    long: 152.9871902,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cowra Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "78 Redfern St",
    phone: "(02) 6342 3222",
    fax: "",
    service: "KP",
    suburb: "Cowra",
    state: "NSW",
    remarks: "",
    postcode: "2794",
    website: "https://www.facebook.com/cowraoutdoorpowerequipmentservice/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.8217385,
    long: 148.6844172,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Cummins Mowers & Motorcycles",
    brand: "REHLKO PETROL",
    address: "28 Railway Terrace",
    phone: "(08) 8676 2044",
    fax: "",
    service: "KP",
    suburb: "Cummins",
    state: "SA",
    remarks: "",
    postcode: "5631",
    website: "https://www.facebook.com/cumminsmm/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.2636136,
    long: 135.7280905,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "D & L Speziali Mowers & Mechanical",
    brand: "REHLKO PETROL",
    address: "19 Silkwood Japoon Rd",
    phone: "(07) 4065 2160",
    fax: "",
    service: "KP",
    suburb: "Silkwood",
    state: "QLD",
    remarks: "",
    postcode: "4856",
    petrol: "Yes",
    diesel: "No",
    lat: -17.7452981,
    long: 146.0178677,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "D & R Hanns",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "145-149 Farm Street",
    phone: "(02) 6385 3856",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Boorowa",
    state: "NSW",
    remarks: "",
    postcode: "2586",
    petrol: "Yes",
    diesel: "Yes",
    lat: -34.4490697,
    long: 148.7223552,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Dalby Mower Supplies",
    brand: "REHLKO PETROL",
    address: "1 Drayton St",
    phone: "(07) 4669 6885",
    fax: "",
    service: "KP",
    suburb: "Dalby",
    state: "QLD",
    remarks: "",
    postcode: "4405",
    website: "https://www.dalbymowersupplies.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.1788292,
    long: 151.2593569,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Dave's Mower Repairs & Sales",
    brand: "REHLKO PETROL",
    address: "58 Anders St",
    phone: "(07) 5512 4372",
    fax: "",
    service: "KP",
    suburb: "Jimboomba",
    state: "QLD",
    remarks: "",
    postcode: "4280",
    website: "https://www.davesmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.8253054,
    long: 153.0311198,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Dawmac Industries",
    brand: "REHLKO PETROL",
    address: "14 Chanter Street",
    phone: "(03) 5885 2382",
    fax: "",
    service: "KP",
    suburb: "Berrigan",
    state: "NSW",
    remarks: "",
    postcode: "2712",
    website: "https://www.dawmac.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.6575368,
    long: 145.8110547,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Dawn Mowers Commercial Service Center",
    brand: "REHLKO PETROL",
    address: "17 Decor Drive",
    phone: "(03) 9796 3070",
    fax: "",
    service: "KP",
    suburb: "Hallam",
    state: "VIC",
    remarks: "",
    postcode: "3803",
    website: "https://dawn.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.0070494,
    long: 145.2621252,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Days Motorcycles & Power Equipment",
    brand: "REHLKO PETROL",
    address: "2A Commerical Drive",
    phone: "(03) 5783 3500",
    fax: "",
    service: "KP",
    suburb: "Wallan",
    state: "VIC",
    remarks: "",
    postcode: "3756",
    website: "https://daysmpe.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: 37.4183644,
    long: 145.0025383,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Days Mower Services",
    brand: "REHLKO PETROL",
    address: "17 Nowra Lane",
    phone: "(02) 4421 4468",
    fax: "",
    service: "KP",
    suburb: "Nowra",
    state: "NSW",
    remarks: "",
    postcode: "2541",
    website: "https://www.facebook.com/DaysMowerService/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.8762336,
    long: 150.6037362,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "DCM industries",
    brand: "REHLKO PETROL",
    address: "8 Maguire Lane",
    phone: "0429 832 422",
    fax: "",
    service: "KP",
    suburb: "Stanthorpe",
    state: "QLD",
    remarks: "",
    postcode: "4380",
    petrol: "Yes",
    diesel: "No",
    lat: -28.6473328,
    long: 151.9590562,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Deakin Motorcycles & Bicycles",
    brand: "REHLKO PETROL",
    address: "24-28 Deakin Ave",
    phone: "(03) 5022 7088",
    fax: "",
    service: "KP",
    suburb: "Mildura",
    state: "VIC",
    remarks: "",
    postcode: "3500",
    website: "https://deakinmotorcycles.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.1846351,
    long: 142.1637573,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Deniliquin Auto Electrical",
    brand: "REHLKO PETROL",
    address: "336 Cressy St",
    phone: "(03) 5881 1077",
    fax: "",
    service: "KP",
    suburb: "Deniliquin",
    state: "NSW",
    remarks: "",
    postcode: "2710",
    website: "https://www.deniliquinautoelec.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.528566,
    long: 144.962001,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Diesel & Machinery Pty Ltd",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "2/51 Sunline Drive",
    phone: "(03) 9699 1655",
    fax: "",
    service: "KP|KD",
    suburb: "Truganina",
    state: "VIC",
    remarks: "",
    postcode: "3029",
    website: "https://www.dieselmachinery.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -37.8060652,
    long: 144.7434993,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Diesel Parts & Service",
    brand: "REHLKO DIESEL",
    address: "21 Hilda St",
    phone: "(07) 3640 9400",
    fax: "",
    service: "KD",
    suburb: "Hamilton",
    state: "QLD",
    remarks: "",
    postcode: "4007",
    website: "https://www.dieselparts.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -27.4336833,
    long: 153.0768531,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "Diesels Plus",
    brand: "REHLKO DIESEL",
    address: "6/25 Hanson St",
    phone: "(08) 9356 6088",
    fax: "",
    service: "KD",
    suburb: "Maddington",
    state: "WA",
    remarks: "",
    postcode: "6109",
    website: "http://www.dieselsplus.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -32.0330166,
    long: 115.9961906,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "District Hire & Sales",
    brand: "REHLKO PETROL",
    address: "1615 Warburton Hwy",
    phone: "(03) 5964 6249",
    fax: "",
    service: "KP",
    suburb: "Woori Yallock",
    state: "VIC",
    remarks: "",
    postcode: "3139",
    website: "https://districthire.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.7800663,
    long: 145.531481,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "DMS Diesels",
    brand: "REHLKO DIESEL",
    address: "Po Box 937",
    phone: "(08) 9075 4418",
    fax: "",
    service: "KD",
    suburb: "Esperance",
    state: "WA",
    remarks: "",
    postcode: "6450",
    petrol: "No",
    diesel: "Yes",
    lat: -33.8608027,
    long: 121.8896205,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Double R Equipment",
    brand: "REHLKO DIESEL",
    address: "339 New England Highway",
    phone: "(02) 6571 4249",
    fax: "",
    service: "KD",
    suburb: "Rutherford ",
    state: "NSW",
    remarks: "",
    postcode: "2320",
    website: "https://dblr.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -32.7107088,
    long: 151.5137277,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Dover & Sons",
    brand: "REHLKO PETROL",
    address: "57 High Street",
    phone: "(07) 5460 6600",
    fax: "",
    service: "KP",
    suburb: "Boonah",
    state: "QLD",
    remarks: "",
    postcode: "4310",
    website: "https://www.doverandsons.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.9960348,
    long: 152.6822052,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Dubbo Mowers & Chainsaws",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "28 Cobbora Rd",
    phone: "(02) 6882 3122",
    fax: "",
    service: "EFI|KP",
    suburb: "Dubbo",
    state: "NSW",
    remarks: "",
    postcode: "2830",
    petrol: "Yes",
    diesel: "No",
    lat: -32.2432578,
    long: 148.615865,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Eaglehawk Small Engines",
    brand: "REHLKO PETROL",
    address: "125 Victoria St",
    phone: "(03) 5446 2644",
    fax: "",
    service: "KP",
    suburb: "Eaglehawk",
    state: "VIC",
    remarks: "",
    postcode: "3556",
    petrol: "Yes",
    diesel: "No",
    lat: -36.7241701,
    long: 144.2503123,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Earthmoving Equipment Australia",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "15 Stanton Rd",
    phone: "(02) 9671 1000",
    fax: "",
    service: "EFI|KP",
    suburb: "Seven Hills",
    state: "NSW",
    remarks: "",
    postcode: "2147",
    website: "https://www.eeaustralia.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.7707329,
    long: 150.9517372,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Eastern Hills Chainsaws & Mowers",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "Unit B 7545 Great Eastern Hwy",
    phone: "(08) 9295 2466",
    fax: "",
    service: "EFI|KP",
    suburb: "Mundaring",
    state: "WA",
    remarks: "",
    postcode: "6073",
    website: "https://easternhills.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.9018587,
    long: 116.1699436,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Eastside Chainsaws & Mowers",
    brand: "REHLKO PETROL",
    address: "39 A Mornington Road",
    phone: "(03) 6245 0063",
    fax: "",
    service: "KP",
    suburb: "Mornington",
    state: "TAS",
    remarks: "",
    postcode: "7018",
    website: "https://www.facebook.com/ecamservice/",
    petrol: "Yes",
    diesel: "No",
    lat: -42.8590044,
    long: 147.397097,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Economy Mowers",
    brand: "REHLKO PETROL",
    address: "64 Bells Line Of Rd",
    phone: "(02) 4571 3656",
    fax: "",
    service: "KP",
    suburb: "North Richmond",
    state: "NSW",
    remarks: "",
    postcode: "2754",
    website: "https://www.economymowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.5787307,
    long: 150.7189313,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "EE DAY & SONS Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "822 Howitt St.,",
    phone: "(03) 5339 2211",
    fax: "",
    service: "KP",
    suburb: "Wendouree",
    state: "VIC",
    remarks: "",
    postcode: "3355",
    website: "https://www.daysons.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.5418426,
    long: 143.8462341,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "EIP Power Solutions",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "37 Eddie Road",
    phone: "(02) 9675 3444",
    fax: "",
    service: "KP|KD",
    suburb: "Minchinbury",
    state: "NSW",
    remarks: "",
    postcode: "2770",
    website: "https://www.eippowersolutions.com/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -33.7848915,
    long: 150.8195806,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Elliot Bros",
    brand: "REHLKO PETROL",
    address: "43-47 Wattle St",
    phone: "(03) 5443 5555",
    fax: "",
    service: "KP",
    suburb: "Bendigo",
    state: "VIC",
    remarks: "",
    postcode: "3550",
    website: "https://elliottbros.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.7624782,
    long: 144.2734316,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Elliotts Small Engines Busselton",
    brand: "REHLKO PETROL",
    address: "55 Strelly St",
    phone: "(08) 9754 1544",
    fax: "",
    service: "KP",
    suburb: "Busselton",
    state: "WA",
    remarks: "",
    postcode: "6280",
    website: "https://elliotts.biz/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.6600736,
    long: 115.3505332,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Emmett Motors",
    brand: "REHLKO PETROL",
    address: "105 Dimboola Road",
    phone: "(03) 5362 3000",
    fax: "",
    service: "KP",
    suburb: "Horsham",
    state: "VIC",
    remarks: "",
    postcode: "3400",
    website: "https://www.emmetts.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.7032606,
    long: 142.1797015,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Equipment & Service Co",
    brand: "REHLKO PETROL",
    address: "11 May Street",
    phone: "(02) 6895 4222",
    fax: "",
    service: "KP",
    suburb: "Condobolin ",
    state: "NSW",
    remarks: "",
    postcode: "2877",
    website: "https://www.equipserv.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.0802891,
    long: 147.1634766,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Equipment Services & Machinery",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "1816 Ipswich Road",
    phone: "(07) 3607 3311",
    fax: "",
    service: "KP|KD",
    suburb: "Rocklea",
    state: "QLD",
    remarks: "",
    postcode: "4106",
    website: "https://equipmentservices.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -27.5617385,
    long: 152.9966386,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Esperance Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "13 Norseman Road",
    phone: "(08) 9071 6389",
    fax: "",
    service: "KP",
    suburb: "Esperance",
    state: "WA",
    remarks: "",
    postcode: "6450",
    website: "https://www.facebook.com/EsperanceOutdoorPowerEquipment/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.842784,
    long: 121.9004588,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Eurells P/L",
    brand: "REHLKO PETROL",
    address: "16 Bolton Street",
    phone: "(02) 6959 2949",
    fax: "",
    service: "KP",
    suburb: "Narrandera",
    state: "NSW",
    remarks: "",
    postcode: "2700",
    website: "https://eurells.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.7461198,
    long: 146.5542675,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Exeter Mower & Chainsaw Centre",
    brand: "REHLKO PETROL",
    address: "79 Main Road",
    phone: "(03) 6394 3059",
    fax: "",
    service: "KP",
    suburb: "Exeter",
    state: "TAS",
    remarks: "",
    postcode: "7275",
    website: "https://www.exetermowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -41.2984023,
    long: 146.9507861,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Extreme Motorcycles",
    brand: "REHLKO PETROL",
    address: "10 Albrecht St",
    phone: "(07) 4091 1740",
    fax: "",
    service: "KP",
    suburb: "Atherton",
    state: "QLD",
    remarks: "",
    postcode: "4882",
    website: "https://www.extrememotorcycles.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -17.2333247,
    long: 145.4813085,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Fairbank Autopro",
    brand: "REHLKO PETROL",
    address: "10 Barton St",
    phone: "(02) 6836 1111",
    fax: "",
    service: "KP",
    suburb: "Cobar",
    state: "NSW",
    remarks: "",
    postcode: "2835",
    website: "https://www.facebook.com/fairbank.autopro/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.4982827,
    long: 145.8368097,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Fairway Mowers & Machinery",
    brand: "REHLKO PETROL",
    address: "49 Alexanders Road",
    phone: "(03) 5133 9600",
    fax: "",
    service: "KP",
    suburb: "Morwell",
    state: "VIC",
    remarks: "",
    postcode: "3840",
    website: "https://fairwaymowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.2269498,
    long: 146.4419372,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Farm & Garden Products",
    brand: "REHLKO PETROL",
    address: "396 Yaamba Rd",
    phone: "(07) 4926 1414",
    fax: "",
    service: "KP",
    suburb: "North Rockhampton",
    state: "QLD",
    remarks: "",
    postcode: "4701",
    website: "https://www.farmandgarden.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.343007,
    long: 150.5213079,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Farm City Pty Ltd",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "35 Parramatta Road",
    phone: "(02) 9748 2222",
    fax: "",
    service: "KP|KD",
    suburb: "Lidcombe",
    state: "NSW",
    remarks: "",
    postcode: "2141",
    website: "https://farmcity.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -33.846727,
    long: 151.0461621,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Farm Moto",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "155 Casino Street Sth",
    phone: "(02) 6622 3999",
    fax: "",
    service: "EFI|KP",
    suburb: "Lismore",
    state: "NSW",
    remarks: "",
    postcode: "2480",
    website: "https://www.farmmoto.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -28.8069961,
    long: 153.2579978,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Forbes Machinery Centre",
    brand: "REHLKO PETROL",
    address: "2 Parkes Road",
    phone: "(02) 6852 3211",
    fax: "",
    service: "KP",
    suburb: "Forbes",
    state: "NSW",
    remarks: "",
    postcode: "2871",
    website: "https://www.forbesmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.3787533,
    long: 148.0123854,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Forbes Small Engine Specialists",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "25 Union Street",
    phone: "(02) 6852 3228",
    fax: "",
    service: "EFI|KP",
    suburb: "Forbes",
    state: "NSW",
    remarks: "",
    postcode: "2871",
    website: "https://forbessmallengines.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -33.3769254,
    long: 148.0094132,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Formatt Machinery",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "122 Enterprise Street",
    phone: "(07) 4151 2381",
    fax: "",
    service: "KP|KD",
    suburb: "Bundaberg",
    state: "QLD",
    remarks: "",
    postcode: "4670",
    website: "https://formattmachinery.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -24.891823,
    long: 152.3363544,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Fred Hopkins W.A.",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "288 Welshpool Road",
    phone: "(08) 9351 9000",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Welshpool",
    state: "WA",
    remarks: "",
    postcode: "6102",
    website: "https://www.fredhopkinswa.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -31.9973443,
    long: 115.9532195,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "Gendore Tractors and Machinery",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "82-84 Yarragon Road",
    phone: "(03) 5998 3216",
    fax: "",
    service: "KP|KD",
    suburb: "Leongatha",
    state: "VIC",
    remarks: "",
    postcode: "3953",
    website: "https://www.gendore.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -38.4672012,
    long: 145.9597473,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "General Mowers & Power Equipment",
    brand: "REHLKO PETROL",
    address: "4 Chetwynd Street",
    phone: "(07) 3209 6580",
    fax: "",
    service: "KP",
    suburb: "Loganholme",
    state: "QLD",
    remarks: "",
    postcode: "4129",
    website: "https://generalmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.6780934,
    long: 153.186707,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Geoff's Mowers",
    brand: "REHLKO PETROL",
    address: "83 Bourke Street",
    phone: "(03) 5623 4931",
    fax: "",
    service: "KP",
    suburb: "Warragul",
    state: "VIC",
    remarks: "",
    postcode: " 3820",
    petrol: "Yes",
    diesel: "No",
    lat: -38.1611605,
    long: 145.9218004,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Geographe Saws & Mowers",
    brand: "REHLKO PETROL",
    address: "50 Barlee Street",
    phone: "(08) 9754 1763",
    fax: "",
    service: "KP",
    suburb: "Busselton",
    state: "WA",
    remarks: "",
    postcode: "6280",
    website: "https://www.geographesawsnmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.661721,
    long: 115.3479737,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Georges Mowers",
    brand: "REHLKO PETROL",
    address: "73 Lloyd St",
    phone: "(03) 5127 5045",
    fax: "",
    service: "KP",
    suburb: "Moe",
    state: "VIC",
    remarks: "",
    postcode: "3825",
    website: "https://www.facebook.com/people/Georges-Mowers/100093364603661/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.1780474,
    long: 146.2586712,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Geraldton Mower & Repair Specialists",
    brand: "REHLKO PETROL",
    address: "130 Flores Road",
    phone: "(08) 9964 4036",
    fax: "",
    service: "KP",
    suburb: "Geraldton",
    state: "WA",
    remarks: "",
    postcode: "6530",
    website: "https://geraldtonmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.7509136,
    long: 114.6284061,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Gippsland Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "533 Princes Drive",
    phone: "(03) 5134 8899",
    fax: "",
    service: "KP",
    suburb: "Morwell",
    state: "VIC",
    remarks: "",
    postcode: "3840",
    website: "https://gippsland-mowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.2324476,
    long: 146.4378255,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Giueni Motors",
    brand: "REHLKO PETROL",
    address: "14 Ernest Street",
    phone: "(07) 4061 2944",
    fax: "",
    service: "KP",
    suburb: "Innisfail",
    state: "QLD",
    remarks: "",
    postcode: "4860",
    website: "https://www.facebook.com/p/Giueni-Motors-Innisfail-100069708927096/",
    petrol: "Yes",
    diesel: "No",
    lat: -17.5272801,
    long: 146.028515,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Glasgow Engineering",
    brand: "REHLKO DIESEL",
    address: "60 William St",
    phone: "(03) 6331 3499",
    fax: "",
    service: "KD",
    suburb: "Launceston",
    state: "TAS",
    remarks: "",
    postcode: "7250",
    website: "https://glasgowengineering.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -41.4336855,
    long: 147.1352704,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "Gloucester Outdoor Solutions",
    brand: "REHLKO PETROL",
    address: "7 Market St",
    phone: "(02) 6558 1612",
    fax: "",
    service: "KP",
    suburb: "Gloucester",
    state: "NSW",
    remarks: "",
    postcode: "2422",
    website: "https://www.gloucesteroutdoorsolutions.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.006151,
    long: 151.9617165,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Gold City Motorcycles",
    brand: "REHLKO PETROL",
    address: "226 Gill Street",
    phone: "(07) 4787 2288",
    fax: "",
    service: "KP",
    suburb: "Charters Towers",
    state: "QLD",
    remarks: "",
    postcode: "4820",
    website: "https://www.goldcitymotorcycles.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -20.077396,
    long: 146.2665677,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Goondiwindi Mower & Bearings",
    brand: "REHLKO PETROL",
    address: "94A Riddle St",
    phone: "(07) 4671 2044",
    fax: "",
    service: "KP",
    suburb: "Goondiwindi",
    state: "QLD",
    remarks: "",
    postcode: "4390",
    website: "https://www.facebook.com/goondiwindimowerandbearings/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.5295693,
    long: 150.2953613,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Gosford Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "Unit 1, 375 Manns Road",
    phone: "(02) 4321 0355",
    fax: "",
    service: "KP",
    suburb: "West Gosford",
    state: "NSW",
    remarks: "",
    postcode: "2250",
    website: "https://gosfordmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.4210087,
    long: 151.3190617,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Goulpro Power Pumps and Sheds",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "25 Sydney Road",
    phone: "(02) 4822 4895",
    fax: "",
    service: "KP|KD",
    suburb: "Goulburn",
    state: "NSW",
    remarks: "",
    postcode: "2580",
    website: "https://goulpro.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -34.7473524,
    long: 149.745234,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Grafton Power Products",
    brand: "REHLKO PETROL",
    address: "119 Prince Street",
    phone: "(02) 6642 2880",
    fax: "",
    service: "KP",
    suburb: "Grafton",
    state: "NSW",
    remarks: "",
    postcode: "2460",
    website: "https://www.graftonpowerproducts.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -29.6880494,
    long: 152.9349559,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Grass Mower Centre",
    brand: "REHLKO PETROL",
    address: "6 Blumer Ave",
    phone: "(02) 4954 5814",
    fax: "",
    service: "KP",
    suburb: "Griffith",
    state: "NSW",
    remarks: "",
    postcode: "2680",
    petrol: "Yes",
    diesel: "No",
    lat: -34.2884563,
    long: 146.059176,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Grays Auto Electrics",
    brand: "REHLKO PETROL",
    address: "71 Aberford St",
    phone: "(02) 6822 1899",
    fax: "",
    service: "KP",
    suburb: "Coonamble",
    state: "NSW",
    remarks: "",
    postcode: "2829",
    petrol: "Yes",
    diesel: "No",
    lat: -30.953864,
    long: 148.38284,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Great Lakes Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "4/16 Douglas Ave",
    phone: "(02) 6555 6528",
    fax: "",
    service: "KP",
    suburb: "Tuncurry",
    state: "NSW",
    remarks: "",
    postcode: "2428",
    website: "https://www.greatlakesmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.1639138,
    long: 152.4919815,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Greater West Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "1431 Elizabeth Drive",
    phone: "(02) 9826 1235",
    fax: "",
    service: "KP",
    suburb: "Kemps Creek",
    state: "NSW",
    remarks: "",
    postcode: "2178",
    website: "https://greaterwestope.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.8798998,
    long: 150.7925016,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Griffith Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "26/28 Bridge Road",
    phone: "(02) 6962 6537",
    fax: "",
    service: "KP",
    suburb: "Griffith",
    state: "NSW",
    remarks: "",
    postcode: "2680",
    website: "https://gmc.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.2925316,
    long: 146.0550483,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Guildford Garden Machinery",
    brand: "REHLKO PETROL",
    address: "9/46 James Street",
    phone: "(08) 9279 6977",
    fax: "",
    service: "KP",
    suburb: "Guildford",
    state: "WA",
    remarks: "",
    postcode: "6055",
    website: "https://www.guildfordgardenmachinery.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.898992,
    long: 115.9774274,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Guttler Diesel",
    brand: "REHLKO DIESEL",
    address: "373 Willowbank Road",
    phone: "0427 693 406",
    fax: "",
    service: "KD",
    suburb: "East Albury",
    state: "NSW",
    remarks: "",
    postcode: "2640",
    website: "https://www.guttlerdiesel.com/",
    petrol: "No",
    diesel: "Yes",
    lat: -36.094242,
    long: 146.9273529,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "GW Industrial",
    brand: "REHLKO DIESEL",
    address: "287 Nebo Road",
    phone: "(07) 4842 9300",
    fax: "",
    service: "KD",
    suburb: "Mackay",
    state: "QLD",
    remarks: "",
    postcode: "4740",
    website: "https://www.gwind.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -21.1646423,
    long: 149.1567229,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "GWS Machinery",
    brand: "REHLKO PETROL",
    address: "5 Walker Street",
    phone: "(02) 4577 4622",
    fax: "",
    service: "KP",
    suburb: "South Windsor",
    state: "NSW",
    remarks: "",
    postcode: "2756",
    website: "https://www.gwsmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.6205157,
    long: 150.8108257,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "GYC Pty Ltd",
    brand: "REHLKO PETROL",
    address: "133 Boundary Road",
    phone: "(02) 9584 5885",
    fax: "",
    service: "KP",
    suburb: "Peakhurst",
    state: "NSW",
    remarks: "",
    postcode: "2210",
    website: "https://www.mygyc.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.9601895,
    long: 151.0645333,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Harris Equipment Repairs",
    brand: "REHLKO PETROL",
    address: "54 Bombala Street",
    phone: "(02) 6452 7160",
    fax: "",
    service: "KP",
    suburb: "Cooma",
    state: "NSW",
    remarks: "",
    postcode: "2630",
    website: "https://harrisequipmentrep.wixsite.com/website",
    petrol: "Yes",
    diesel: "No",
    lat: -36.236518,
    long: 149.1286464,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Harveys Mowers & Chainsaw Centre",
    brand: "REHLKO PETROL",
    address: "48 Pearson Street",
    phone: "(02) 6925 2234",
    fax: "",
    service: "KP",
    suburb: "Wagga Wagga",
    state: "NSW",
    remarks: "",
    postcode: "2650",
    website: "https://www.facebook.com/p/Harveys-Mower-and-Chainsaw-Centre-100071551615783/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.1172491,
    long: 147.3445929,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Heidelberg Mowers",
    brand: "REHLKO PETROL",
    address: "66 Bell Street",
    phone: "(03) 9458 1220",
    fax: "",
    service: "KP",
    suburb: "Heidelberg",
    state: "VIC",
    remarks: "",
    postcode: "3081",
    website: "https://aumowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.7537302,
    long: 145.0542042,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Hempfield Small Motor Services",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "Unit 1  266 Welshpool Road",
    phone: "(08) 9451 4833",
    fax: "",
    service: "KP|KD",
    suburb: "Welshpool Bc",
    state: "WA",
    remarks: "",
    postcode: "6106",
    website: "https://www.hempfieldsmallmotors.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -31.9970502,
    long: 115.9506066,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Henderson Mowers & Chainsaws",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "119 Mair St East",
    phone: "(03) 5331 1618",
    fax: "",
    service: "KP|KD",
    suburb: "Ballarat",
    state: "VIC",
    remarks: "",
    postcode: "3350",
    website: "https://www.hendersonmowers.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -37.5607508,
    long: 143.8697758,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Hewitt and Whitty Ballarat",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "2 Wiltshire Lane",
    phone: "(03) 5336 1344",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Ballarat",
    state: "VIC",
    remarks: "",
    postcode: "3350",
    website: "https://www.hewittandwhitty.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -37.5701656,
    long: 143.8091365,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "Hillman Motors",
    brand: "REHLKO DIESEL",
    address: "204 Denison St",
    phone: "(07) 4927 2355",
    fax: "",
    service: "KD",
    suburb: "Rockhampton City",
    state: "QLD",
    remarks: "",
    postcode: "4700",
    website: "https://www.hillmanmotors.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -23.3811383,
    long: 150.5102075,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Hinterland Mowers",
    brand: "REHLKO PETROL",
    address: "38 Spencer St",
    phone: "(07) 5578 1999",
    fax: "",
    service: "KP",
    suburb: "Nerang",
    state: "QLD",
    remarks: "",
    postcode: "4211",
    website: "https://hinterlandmowers.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.0013565,
    long: 153.3403595,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Hollander Imports",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "87 Brooker Hwy",
    phone: "(03) 6234 5111",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Glebe",
    state: "TAS",
    remarks: "",
    postcode: "7000",
    website: "https://www.facebook.com/p/Hollander-Imports-100054476829768/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -42.8762144,
    long: 147.3279992,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "Hunter Outdoor Equipment",
    brand: "REHLKO PETROL",
    address: "503-509 High Street",
    phone: "(02) 4933 6989",
    fax: "",
    service: "KP",
    suburb: "Maitland",
    state: "NSW",
    remarks: "",
    postcode: "2320",
    website: "https://www.facebook.com/hunteroutdoorequipment/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.7306847,
    long: 151.5524756,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Illawarra Mowers",
    brand: "REHLKO PETROL",
    address: "6/175-177 Five Islands Road",
    phone: "(02) 4216 8033",
    fax: "",
    service: "KP",
    suburb: "Unanderra",
    state: "NSW",
    remarks: "",
    postcode: "2526",
    website: "https://illawarramowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.4606035,
    long: 150.8660528,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ingham Motorcycles and Mowers",
    brand: "REHLKO PETROL",
    address: "31 Herbert Street",
    phone: "(07) 4776 2973",
    fax: "",
    service: "KP",
    suburb: "Ingham",
    state: "QLD",
    remarks: "",
    postcode: "4850",
    website: "https://inghammotorcyclesandmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -18.6491107,
    long: 146.1582794,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Intersales Temora",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "80 Hoskins St",
    phone: "(02) 6977 1933",
    fax: "",
    service: "KP|KD",
    suburb: "Temora",
    state: "NSW",
    remarks: "",
    postcode: "2666",
    website: "https://www.intersales.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -34.4417662,
    long: 147.5309688,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Inverell Power Farm Co",
    brand: "REHLKO PETROL",
    address: "287-295 Byron St",
    phone: "(02) 6722 3388",
    fax: "",
    service: "KP",
    suburb: "Inverell",
    state: "NSW",
    remarks: "",
    postcode: "2360",
    website: "https://www.inverellpowerfarm.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -29.7670168,
    long: 151.1215835,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Inverell Truck & Diesel Repairs",
    brand: "REHLKO DIESEL",
    address: "103-105 Ring St",
    phone: "(02) 6722 1111",
    fax: "",
    service: "KD",
    suburb: "Inverell",
    state: "NSW",
    remarks: "",
    postcode: "2360",
    website: "https://www.itdr.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -29.7637136,
    long: "151.1062772!",
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ireland's Machinery Pty Ltd",
    brand: "REHLKO PETROL",
    address: "Unit 1/11 Pikkat Dr",
    phone: "(02) 4872 1999",
    fax: "",
    service: "KP",
    suburb: "Braemar ",
    state: "NSW",
    remarks: "",
    postcode: "2575",
    website: "https://www.irelandsmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.4256204,
    long: 150.4915312,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Irons Auto Repairs",
    brand: "REHLKO PETROL",
    address: "138 Jubilee Street",
    phone: "(02) 6645 2739",
    fax: "",
    service: "KP",
    suburb: "Townsend",
    state: "NSW",
    remarks: "",
    postcode: "2463",
    website: "https://www.ironsautorepairs.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -29.4667625,
    long: 153.2248865,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "J & B Marine",
    brand: "REHLKO PETROL",
    address: "102 Cartwright St",
    phone: "(07) 4776 1188",
    fax: "",
    service: "KP",
    suburb: "Ingham",
    state: "QLD",
    remarks: "",
    postcode: "4850",
    website: "https://www.jandbmarine.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -18.6463291,
    long: 146.1627163,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "J.C Spares",
    brand: "REHLKO PETROL",
    address: "96 Beardy Street",
    phone: "(02) 6771 4444",
    fax: "",
    service: "KP",
    suburb: "Armidale",
    state: "NSW",
    remarks: "",
    postcode: "2350",
    petrol: "Yes",
    diesel: "No",
    lat: -30.5148044,
    long: 151.670196,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Jacksons Mower Centre",
    brand: "REHLKO PETROL",
    address: "15 Victoria Street",
    phone: "(07) 4957 5450",
    fax: "",
    service: "KP",
    suburb: "Mackay",
    state: "QLD",
    remarks: "",
    postcode: "4740",
    website: "https://www.jacksonsmowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -21.1424131,
    long: 149.1929608,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Jacobsen's Automotive Engineering",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "34 Production Street",
    phone: "(07) 4151 3036",
    fax: "",
    service: "KP|KD",
    suburb: "Bundaberg",
    state: "QLD",
    remarks: "",
    postcode: "4670",
    website: "https://jacobsens.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -24.8932521,
    long: 152.3310219,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Jak Outdoor Power Equipment",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "19 Evans Ave",
    phone: "(07) 4953 4000",
    fax: "",
    service: "EFI|KP",
    suburb: "North Mackay",
    state: "QLD",
    remarks: "",
    postcode: "4740",
    website: "https://jakope.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -21.1267043,
    long: 149.1886703,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "JC Machinery & Equipment",
    brand: "REHLKO PETROL",
    address: "Unit17/3-9 Octal Street",
    phone: "0423 396 057",
    fax: "",
    service: "KP",
    suburb: "Yatala",
    state: "QLD",
    remarks: "",
    postcode: "4207",
    website: "https://www.jcmachineryequipment.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.7604404,
    long: 153.23515,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Jennings Mowers",
    brand: "REHLKO PETROL",
    address: "170 Lovell Street",
    phone: "(02) 6382 5033",
    fax: "",
    service: "KP",
    suburb: "Young",
    state: "NSW",
    remarks: "",
    postcode: "2594",
    website: "https://www.facebook.com/JenningsMowersandSaws/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.3102488,
    long: 148.2877672,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "John's Bikes & Mowers Ballina",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "8 Southern Cross Drive",
    phone: "(02) 6681 1861",
    fax: "",
    service: "EFI|KP",
    suburb: "Ballina",
    state: "NSW",
    remarks: "",
    postcode: "2478",
    website: "https://johnsbikesandmowers.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.8514327,
    long: 153.5563832,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "JR's Mower & Motorcycle",
    brand: "REHLKO PETROL",
    address: "86 Macleod St",
    phone: "(03) 5152 3202",
    fax: "",
    service: "KP",
    suburb: "Bairnsdale",
    state: "VIC",
    remarks: "",
    postcode: "3875",
    website: "https://www.facebook.com/jrsbairnsdale/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.8271764,
    long: 147.6307279,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "JSL Light Engine Repairs",
    brand: "REHLKO PETROL",
    address: "48 Yarragon Road",
    phone: "(03) 5662 3933",
    fax: "",
    service: "KP",
    suburb: "Leongatha",
    state: "VIC",
    remarks: "",
    postcode: "3953",
    website: "https://www.facebook.com/discountmowersales/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.466926,
    long: 145.9564372,
    isDieselExpert: "145.9564372!2",
    isPetrolExpert: "145.9564372!3"
  },
  {
    name: "Judds Engineering",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "21 Dobney Ave",
    phone: "(02) 6925 1642",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Wagga Wagga",
    state: "NSW",
    remarks: "",
    postcode: "2650",
    website: "https://www.juddsengineering.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -35.1175881,
    long: 147.3475425,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "JW Farm and Garden Equipment Pty Ltd",
    brand: "REHLKO PETROL",
    address: "385 Tennyson Road",
    phone: "(02) 4576 5555",
    fax: "",
    service: "KP",
    suburb: "Tennyson",
    state: "NSW",
    remarks: "",
    postcode: "2756",
    website: "https://jwfge.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.5258615,
    long: 150.7434305,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Karl's Mower Service",
    brand: "REHLKO PETROL",
    address: "Unit 1/1 Flint Court",
    phone: "(07) 5593 4899",
    fax: "",
    service: "KP",
    suburb: "Varsity Lakes",
    state: "QLD",
    remarks: "",
    postcode: "4227",
    website: "https://www.karlsmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.1007114,
    long: "153.4126559!1",
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "KC Equipment",
    brand: "REHLKO PETROL",
    address: "4 Kaycee Place",
    phone: "(07) 3297 3000",
    fax: "",
    service: "KP",
    suburb: "Yatala",
    state: "QLD",
    remarks: "",
    postcode: "4207",
    website: "https://www.kcequipment.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.7341645,
    long: 153.2238531,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Keith Simmons Engineering",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "169 Lovell Street",
    phone: "(02) 6382 3999",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Young",
    state: "NSW",
    remarks: "",
    postcode: "2594",
    website: "https://www.facebook.com/simmosengineering/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -34.3099632,
    long: 148.2882843,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Kenilworth Rural Supplies",
    brand: "REHLKO PETROL",
    address: "47 Elizabeth St",
    phone: "(07) 5472 3100",
    fax: "",
    service: "KP",
    suburb: "Kenilworth",
    state: "QLD",
    remarks: "",
    postcode: "4574",
    website: "https://www.kenilworthruralsupplies.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.5923633,
    long: 152.7275738,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Kenmore Mower & Power Equipment",
    brand: "REHLKO PETROL",
    address: "10/615 Seventeen Mile Rocks Rd",
    phone: "(07) 3376 5221",
    fax: "",
    service: "KP",
    suburb: "Seventeen Mile Rocks",
    state: "QLD",
    remarks: "",
    postcode: "4073",
    website: "https://kenmoremowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5406031,
    long: 152.9553814,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Kentan Machinery",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "338 Pacific Highway",
    phone: "(02) 4964 8275",
    fax: "",
    service: "KP|KD",
    suburb: "Hexham",
    state: "NSW",
    remarks: "",
    postcode: "2322",
    website: "https://kentanmachinery.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -32.8309475,
    long: 151.6859711,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Konigs Shepparton",
    brand: "REHLKO PETROL",
    address: "355 Midland Highway",
    phone: "(03) 5821 4411",
    fax: "",
    service: "KP",
    suburb: "Shepparton East",
    state: "VIC",
    remarks: "",
    postcode: "3631",
    website: "https://konigs.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.3884527,
    long: 145.4375196,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Leigh Stoddart & Company",
    brand: "REHLKO PETROL",
    address: "14 Bolaro Street",
    phone: "(02) 6375 1342",
    fax: "",
    service: "KP",
    suburb: "Dunedoo",
    state: "NSW",
    remarks: "",
    postcode: "2844",
    website: "https://www.facebook.com/p/Leigh-Stoddart-Co-Pty-Ltd-100054455052390/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.016509,
    long: 149.3991241,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Lismore Diesel Centre",
    brand: "REHLKO DIESEL",
    address: "180 Wilson St",
    phone: "(02) 6621 3412",
    fax: "",
    service: "KD",
    suburb: "Lismore",
    state: "NSW",
    remarks: "",
    postcode: "2480",
    website: "https://www.lismorediesel.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -28.8168788,
    long: 153.2601231,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "LK Diesel Service",
    brand: "REHLKO DIESEL",
    address: "52 Woodlands Dr",
    phone: "(03) 9588 6900",
    fax: "",
    service: "KD",
    suburb: "Braeside",
    state: "VIC",
    remarks: "",
    postcode: "3195",
    website: "https://www.lkdiesel.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -37.9921953,
    long: 145.1173738,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "Lowrey's Small Motors",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "307 Gosport Street",
    phone: "(02) 6752 2744",
    fax: "",
    service: "KP|KD",
    suburb: "Moree",
    state: "NSW",
    remarks: "",
    postcode: "2400",
    website: "https://www.facebook.com/p/Lowreys-Small-Motors-100041893187573/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -29.4720391,
    long: 149.8469334,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mackay Marine Services",
    brand: "LOMBARDINI MARINE",
    address: "Shed 3, Mulherin Drive",
    phone: "(07) 4955 0200",
    fax: "",
    service: "MAR",
    suburb: "Mackay",
    state: "QLD",
    remarks: "",
    postcode: "4740",
    website: "https://www.mackaymarine.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -21.1142974,
    long: 149.2215446,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mackay Outdoor Power Centre",
    brand: "REHLKO PETROL",
    address: "293 Nebo Rd",
    phone: "(07) 4952 1177",
    fax: "",
    service: "KP",
    suburb: "West Mackay",
    state: "QLD",
    remarks: "",
    postcode: "4740",
    website: "https://mackayoutdoorpowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -21.164856,
    long: 149.156434,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Macleay Valley Mower Centre",
    brand: "REHLKO PETROL",
    address: "40 Lachlan Street",
    phone: "(02) 6562 8822",
    fax: "",
    service: "KP",
    suburb: "Kempsey",
    state: "NSW",
    remarks: "",
    postcode: "2440",
    website: "https://macleaymowers.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.092159,
    long: 152.8372602,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Malanda Rural Suppliers",
    brand: "REHLKO PETROL",
    address: "37 James St",
    phone: "(07) 4096 5455",
    fax: "",
    service: "KP",
    suburb: "Malanda",
    state: "QLD",
    remarks: "",
    postcode: "4885",
    website: "https://www.malandaruralsupplies.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -17.3526706,
    long: 145.5940499,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Maleny Mowers",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "12 Bunya Street",
    phone: "(07) 5494 3144",
    fax: "",
    service: "EFI|KP",
    suburb: "Maleny",
    state: "QLD",
    remarks: "",
    postcode: "4552",
    website: "https://www.malenymowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.7596357,
    long: 152.8547285,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Manjimup Motors",
    brand: "REHLKO PETROL",
    address: "95B Giblett St",
    phone: "(08) 9771 1926",
    fax: "",
    service: "KP",
    suburb: "Manjimup",
    state: "WA",
    remarks: "",
    postcode: "6258",
    website: "https://manjimupmotors.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.2406918,
    long: 116.1464748,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Maranoa Ag & Automotive",
    brand: "REHLKO PETROL",
    address: "182 Raglan St",
    phone: "(07) 4622 4819",
    fax: "",
    service: "KP",
    suburb: "Roma",
    state: "QLD",
    remarks: "",
    postcode: "4455",
    website: "https://www.maaqld.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.5800728,
    long: 148.7744995,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Marriotts Motorcycles & Power Equipment",
    brand: "REHLKO PETROL",
    address: "34 Anderson St",
    phone: "(03) 5662 2028",
    fax: "",
    service: "KP",
    suburb: "Leongatha ",
    state: "VIC",
    remarks: "",
    postcode: "3953",
    website: "https://marriottsmpe.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.4729696,
    long: 145.9430037,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Marshall Mowers",
    brand: "REHLKO PETROL",
    address: "36 Newbey Street",
    phone: "(08) 9841 2199",
    fax: "",
    service: "KP",
    suburb: "Milpara",
    state: "WA",
    remarks: "",
    postcode: "6330",
    website: "https://marshallmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.9919953,
    long: 117.8695867,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Matt's Mowers and More",
    brand: "REHLKO PETROL",
    address: "72 Albion Street",
    phone: "(07) 4661 2032",
    fax: "",
    service: "KP",
    suburb: "Warwick",
    state: "QLD",
    remarks: "",
    postcode: "4370",
    website: "https://mattsmowersandmore.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.2193916,
    long: 152.0347087,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Max ATV Australia",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "6/35 Marjorie St",
    phone: "0412 015 144",
    fax: "",
    service: "KP|KD",
    suburb: "Pinelands ",
    state: "NT",
    remarks: "",
    postcode: "0829",
    website: "https://www.maxatv.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -12.4623543,
    long: 130.9697723,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "MaxiPARTS Gladstone",
    brand: "REHLKO PETROL",
    address: "21 Beckinsale St",
    phone: "(07) 4839 4000",
    fax: "",
    service: "KP",
    suburb: "Gladstone",
    state: "QLD",
    remarks: "",
    postcode: "4680",
    website: "https://www.maxiparts.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.8421857,
    long: 151.2374302,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Melbourne Power Equipment",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "42 Stubbs St",
    phone: "(03) 9376 4333",
    fax: "",
    service: "EFI|KP",
    suburb: "Kensington",
    state: "VIC",
    remarks: "",
    postcode: "3031",
    website: "https://www.facebook.com/melbpower/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.7904534,
    long: 144.9355339,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Melbourne's Mower Centre",
    brand: "REHLKO PETROL",
    address: "22 Greens Road",
    phone: "(03) 9794 8121",
    fax: "",
    service: "KP",
    suburb: "Dandenong South",
    state: "VIC",
    remarks: "",
    postcode: "3175",
    website: "https://melbournesmowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.0152566,
    long: 145.2184992,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Merimbula Mowers & Marine",
    brand: "REHLKO PETROL",
    address: "43 Merimbula Drive",
    phone: "(02) 6495 4495",
    fax: "",
    service: "KP",
    suburb: "Merimbula",
    state: "NSW",
    remarks: "",
    postcode: "2548",
    website: "https://www.merimbulamowersandmarine.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.8877005,
    long: 149.9067615,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mid Coast Mowers",
    brand: "REHLKO PETROL",
    address: "44 Crescent Avenue",
    phone: "(02) 6552 4103",
    fax: "",
    service: "KP",
    suburb: "Taree",
    state: "NSW",
    remarks: "",
    postcode: "2430",
    website: "https://midcoastmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.9068999,
    long: 152.472017,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Midland Mowers & Machinery",
    brand: "REHLKO PETROL",
    address: "367 Great Eastern Highway",
    phone: "(08) 9250 2468",
    fax: "",
    service: "KP",
    suburb: "Midvale",
    state: "WA",
    remarks: "",
    postcode: "6056",
    website: "https://www.midlandmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.8940742,
    long: 116.0305369,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Midwest Mowers & Can-Am",
    brand: "REHLKO PETROL",
    address: "111 Nth West Coastal Hwy",
    phone: "(08) 9921 8300",
    fax: "",
    service: "KP",
    suburb: "Geraldton",
    state: "WA",
    remarks: "",
    postcode: "6530",
    website: "https://midwestmowersgeraldton.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.7696678,
    long: 114.6242328,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Miles Engineering & Hardware Supplies",
    brand: "REHLKO PETROL",
    address: "44-46 Murilla Street",
    phone: "(07) 4627 1488",
    fax: "",
    service: "KP",
    suburb: "Miles",
    state: "QLD",
    remarks: "",
    postcode: "4415",
    website: "https://www.milesengineering.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.659374,
    long: 150.1834865,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Miller Motorsports",
    brand: "REHLKO PETROL",
    address: "495 Raglan Parade",
    phone: "(03) 5562 9653",
    fax: "",
    service: "KP",
    suburb: "Warnambool",
    state: "VIC",
    remarks: "",
    postcode: "3280",
    website: "https://www.millermotosports.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.3826106,
    long: 142.4889005,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mini Motor Service",
    brand: "REHLKO PETROL",
    address: "25 Chinchilla St",
    phone: "(07) 4662 7448",
    fax: "",
    service: "KP",
    suburb: "Chinchilla",
    state: "QLD",
    remarks: "",
    postcode: "4413",
    website: "https://www.facebook.com/p/Mini-Motors-100057639181834/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.7366082,
    long: 150.6252681,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mitchell Lawnmower Centre",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "32 Sandford Street",
    phone: "(02) 6241 4806",
    fax: "",
    service: "EFI|KP",
    suburb: "Mitchell",
    state: "NSW",
    remarks: "",
    postcode: "2911",
    website: "https://www.mitchelllawn.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.22036,
    long: 149.1399999,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mitech Air & Allied Services",
    brand: "REHLKO PETROL",
    address: "37/43 Northridge Rd",
    phone: "(07) 4743 3966",
    fax: "",
    service: "KP",
    suburb: "Kalkadoon",
    state: "QLD",
    remarks: "",
    postcode: "4825",
    website: "https://www.mitechqld.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -20.6824266,
    long: 139.4892884,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Molin Motorcycle & Marine",
    brand: "REHLKO PETROL",
    address: "3-5 Grigg Road",
    phone: "(03) 5451 1500",
    fax: "",
    service: "KP",
    suburb: "Koondrook",
    state: "VIC",
    remarks: "",
    postcode: "3580",
    website: "https://www.molin.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.6310273,
    long: 144.1244444,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Monitor Industries",
    brand: "REHLKO PETROL",
    address: "143 Gunnedah Rd",
    phone: "1800 025 024",
    fax: "",
    service: "KP",
    suburb: "Tamworth ",
    state: "NSW",
    remarks: "",
    postcode: "2340",
    website: "https://monitor.net.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.0972552,
    long: 150.8912467,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Morayfield Mower Centre",
    brand: "REHLKO PETROL",
    address: "291 Morayfield Road",
    phone: "(07) 5498 7794",
    fax: "",
    service: "KP",
    suburb: "Morayfield",
    state: "QLD",
    remarks: "",
    postcode: "4506",
    website: "https://www.morayfieldmowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.113621,
    long: 152.9523707,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Moruya Mower & Chainsaw",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "17-19 Church Street",
    phone: "(02) 4474 3322",
    fax: "",
    service: "EFI|KP",
    suburb: "Moruya",
    state: "NSW",
    remarks: "",
    postcode: "2537",
    website: "https://moruyamowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.9095938,
    long: 150.0828243,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Motor Mecca Toowoomba",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "330 Anzac Avenue",
    phone: "(07) 4634 4577",
    fax: "",
    service: "EFI|KP",
    suburb: "Toowoomba",
    state: "QLD",
    remarks: "",
    postcode: "4350",
    website: "https://www.motormecca.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5862042,
    long: 151.9179746,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Mount Gravatt Mower Centre",
    brand: "REHLKO PETROL",
    address: "1484 Logan Road",
    phone: "(07) 3349 6911",
    fax: "",
    service: "KP",
    suburb: "Mt Gravatt",
    state: "QLD",
    remarks: "",
    postcode: "4122",
    website: "https://mtgravattmowercentre.wixsite.com/mysite",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5382822,
    long: 153.0797399,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mower Accessories",
    brand: "REHLKO PETROL",
    address: "6/26, Township Drive",
    phone: "(07) 5535 4866",
    fax: "",
    service: "KP",
    suburb: "West Burleigh",
    state: "QLD",
    remarks: "",
    postcode: "4219",
    website: "https://moweraccessories.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.112934,
    long: 153.437547,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mower City Tweed Heads",
    brand: "REHLKO PETROL",
    address: "49 Greenway Drive",
    phone: "(07) 5524 4855",
    fax: "",
    service: "KP",
    suburb: "Tweed Heads South",
    state: "NSW",
    remarks: "",
    postcode: "2486",
    website: "https://mowercitytweed.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.2072306,
    long: 153.5371782,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mower Corner",
    brand: "REHLKO PETROL",
    address: "255 Murray Street",
    phone: "(03) 5231 6466",
    fax: "",
    service: "KP",
    suburb: "Colac",
    state: "VIC",
    remarks: "",
    postcode: "3250",
    website: "https://mowercorner.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.3391421,
    long: 143.5819611,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mower Magic",
    brand: "REHLKO PETROL",
    address: "2/16 Rouse Road",
    phone: "(08) 9582 0255",
    fax: "",
    service: "KP",
    suburb: "Mandurah North",
    state: "WA",
    remarks: "",
    postcode: "6210",
    website: "https://www.mowermagic.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.5146106,
    long: 115.7488563,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mower World Darwin",
    brand: "REHLKO PETROL",
    address: "6/51 Pruen Rd",
    phone: "(08) 8947 1227",
    fax: "",
    service: "KP",
    suburb: "Berrimah",
    state: "NT",
    remarks: "",
    postcode: "0828",
    website: "https://www.mowerworlddarwin.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -12.4370702,
    long: 130.9305566,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mower World QLD",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "174 Siganto Drive",
    phone: "(07) 5573 4388",
    fax: "",
    service: "EFI|KP",
    suburb: "Helensvale",
    state: "QLD",
    remarks: "",
    postcode: "4210",
    website: "https://www.mowerworldqld.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.8889739,
    long: 153.3165981,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Mowers & More (Diamond Creek)",
    brand: "REHLKO PETROL",
    address: "272 Diamond Creek Road",
    phone: "(03) 9434 3066",
    fax: "",
    service: "KP",
    suburb: "Diamond Creek",
    state: "VIC",
    remarks: "",
    postcode: "3089",
    website: "https://mowersandmore.net.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.6805639,
    long: 145.1226301,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mowers & More Coffs Harbour",
    brand: "REHLKO PETROL",
    address: "8 Cook Drive",
    phone: "(02) 6651 7580",
    fax: "",
    service: "KP",
    suburb: "Coffs Harbour",
    state: "NSW",
    remarks: "",
    postcode: "2450",
    website: "https://mowersnmore.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -30.3142143,
    long: 153.0974526,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mowers Galore",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "20 Thompson Rd",
    phone: "(03) 5272 1066",
    fax: "",
    service: "EFI|KP",
    suburb: "North Geelong",
    state: "VIC",
    remarks: "",
    postcode: "3215",
    website: "https://www.mowersgalore.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.1231979,
    long: 144.3414898,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mowers Plus",
    brand: "REHLKO PETROL",
    address: "94 King Road",
    phone: "(08) 9791 2240",
    fax: "",
    service: "KP",
    suburb: "Bunbury",
    state: "WA",
    remarks: "",
    postcode: "6230",
    website: "https://mowersplus.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.3393748,
    long: 115.6541133,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Moxham Outdoor Power Equipment",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "10 Davy Ave",
    phone: "(07) 4947 0121",
    fax: "",
    service: "EFI|KP",
    suburb: "Proserpine",
    state: "QLD",
    remarks: "",
    postcode: "4800",
    website: "https://www.moxhamoutdoorpowereq.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -20.4034464,
    long: 148.5866598,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Mudgee Honda Centre",
    brand: "REHLKO PETROL",
    address: "137 Church Street",
    phone: "(02) 6372 3100",
    fax: "",
    service: "KP",
    suburb: "Mudgee",
    state: "NSW",
    remarks: "",
    postcode: "2850",
    website: "https://mudgeehonda.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.6002961,
    long: 149.5872132,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Murwillumbah Mowers & Chainsaws Centre",
    brand: "REHLKO PETROL",
    address: "60-64 Quarry Road",
    phone: "(02) 6672 3272",
    fax: "",
    service: "KP",
    suburb: "Murwillumbah",
    state: "NSW",
    remarks: "",
    postcode: "2484",
    website: "https://murwillumbahmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.3295558,
    long: 153.414889,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Myla Motors St George Pty Ltd",
    brand: "REHLKO PETROL",
    address: "125 Victoria St",
    phone: "(07) 4625 4186",
    fax: "",
    service: "KP",
    suburb: "St George",
    state: "QLD",
    remarks: "",
    postcode: "4487",
    website: "https://www.mylamotorsbrpdealer.com.au/canam",
    petrol: "Yes",
    diesel: "No",
    lat: -28.036909,
    long: 148.5793103,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Naracoorte Motorcycles & Mowers",
    brand: "REHLKO PETROL",
    address: "78 Gordon Street",
    phone: "(08) 8762 3977",
    fax: "",
    service: "KP",
    suburb: "Naracoorte",
    state: "SA",
    remarks: "",
    postcode: "5271",
    website: "https://nmm.net.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.9651867,
    long: 140.7396013,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "North Coast Machinery",
    brand: "REHLKO PETROL",
    address: "6 Dove St",
    phone: "(07) 4061 3422",
    fax: "",
    service: "KP",
    suburb: "Innisfail",
    state: "QLD",
    remarks: "",
    postcode: "4860",
    website: "https://www.facebook.com/nthcoamac/",
    petrol: "Yes",
    diesel: "No",
    lat: -17.5248759,
    long: 146.0251146,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "North West Mowers",
    brand: "REHLKO PETROL",
    address: "25 North Terrace",
    phone: "(03) 6431 4177",
    fax: "",
    service: "KP",
    suburb: "Burnie",
    state: "TAS",
    remarks: "",
    postcode: "7320",
    website: "https://www.northwestmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -41.0488724,
    long: 145.9029914,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Notts's Rural and Domestic",
    brand: "REHLKO PETROL",
    address: "35 Lee Street",
    phone: "(02) 6845 1203",
    fax: "",
    service: "KP",
    suburb: "Wellington",
    state: "NSW",
    remarks: "",
    postcode: "2820",
    website: "https://www.facebook.com/nottsrural/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.5465871,
    long: 148.9411647,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Nowa Power Products",
    brand: "REHLKO PETROL",
    address: "4 Bourbang Street East",
    phone: "(07) 4153 1722",
    fax: "",
    service: "KP",
    suburb: "Bundaberg East",
    state: "QLD",
    remarks: "",
    postcode: "4670",
    website: "https://www.nowa.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -24.8620986,
    long: 152.3630657,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "NQ Power Equipment Pty Ltd",
    brand: "REHLKO PETROL",
    address: "1 Dove St",
    phone: "(07) 4061 1941",
    fax: "",
    service: "KP",
    suburb: "Innisfail",
    state: "QLD",
    remarks: "",
    postcode: "4680",
    website: "https://www.nqpowerequipment.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -17.5244687,
    long: 146.0253635,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "O'Connors",
    brand: "REHLKO PETROL",
    address: "11 Ungarie Rd",
    phone: "(02) 6972 2288",
    fax: "",
    service: "KP",
    suburb: "West Wyalong",
    state: "NSW",
    remarks: "",
    postcode: "2671",
    website: "https://oconnorscaseih.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.9207693,
    long: 147.1981065,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ollies Mower Service",
    brand: "REHLKO PETROL",
    address: "11 Markwell Street",
    phone: "(07) 4162 4533",
    fax: "",
    service: "KP",
    suburb: "Kingaroy",
    state: "QLD",
    remarks: "",
    postcode: "4610",
    website: "https://olliesmowerservice.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.5430449,
    long: 151.8397787,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Orbost Power Equipment Pty Ltd",
    brand: "REHLKO PETROL",
    address: "77 Salisbury St",
    phone: "(03) 5154 1386",
    fax: "",
    service: "KP",
    suburb: "Orbost",
    state: "VIC",
    remarks: "",
    postcode: "3888",
    website: "https://www.facebook.com/p/Orbost-Power-Equipment-Pty-Ltd-100057027927158/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.7053443,
    long: 148.46407,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Outdoor Power Centre",
    brand: "REHLKO PETROL",
    address: "25 Brisbane Rd",
    phone: "(07) 5482 4924",
    fax: "",
    service: "KP",
    suburb: "Gympie",
    state: "QLD",
    remarks: "",
    postcode: "4570",
    website: "https://outdoorpowercentre.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.2022881,
    long: 152.6781051,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ovens Valley Chainsaws and Lawnmowers",
    brand: "REHLKO PETROL",
    address: "52 -54 Myrtleford Street",
    phone: "(03) 5752 1270",
    fax: "",
    service: "KP",
    suburb: "Myrtleford",
    state: "VIC",
    remarks: "",
    postcode: "3737",
    website: "https://www.ovensvalleychainsaws.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.565037,
    long: 146.729154,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "P.K. Equipment",
    brand: "REHLKO PETROL",
    address: "72 Macalister St",
    phone: "(03) 5144 2200",
    fax: "",
    service: "KP",
    suburb: "Sale",
    state: "VIC",
    remarks: "",
    postcode: "3850",
    website: "https://www.pkequipment.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.1095865,
    long: 147.0664903,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Pakenham Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "17 Bald Hill Road",
    phone: "(03) 5941 1344",
    fax: "",
    service: "KP",
    suburb: "Pakenham",
    state: "VIC",
    remarks: "",
    postcode: "3810",
    website: "https://www.pakenhammowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.0818311,
    long: 145.4857559,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Pat's Mower Service",
    brand: "REHLKO PETROL",
    address: "Unit 2/8 Marcia St",
    phone: "(02) 6651 1743",
    fax: "",
    service: "KP",
    suburb: "Coffs Harbour",
    state: "NSW",
    remarks: "",
    postcode: "2450",
    website: "https://www.facebook.com/patsmowerservicepty/",
    petrol: "Yes",
    diesel: "No",
    lat: -30.2893667,
    long: 153.1158168,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Paulls Richmond Mowers",
    brand: "REHLKO PETROL",
    address: "293 Windsor Street",
    phone: "(02) 4578 1033",
    fax: "",
    service: "KP",
    suburb: "Richmond",
    state: "NSW",
    remarks: "",
    postcode: "2753",
    website: "https://paullsrichmond.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.59539,
    long: 150.7485358,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Pellows Saws & Mowers",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "223 Invermay Road",
    phone: "(03) 6326 5722",
    fax: "",
    service: "EFI|KP",
    suburb: "Launceston",
    state: "TAS",
    remarks: "",
    postcode: "7250",
    website: "https://pellows.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -41.4173926,
    long: 147.1339439,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Peters Offroad & Outdoor",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "417 Mulgrave Road",
    phone: "(07) 4051 0022",
    fax: "",
    service: "KP|KD",
    suburb: "Earlville",
    state: "QLD",
    remarks: "",
    postcode: "4870",
    website: "https://petersatv.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -16.9393075,
    long: 145.7450545,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Phoenix Powersports",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "165 Paradise Street",
    phone: "(07) 4952 2436",
    fax: "",
    service: "EFI|KP",
    suburb: "Mackay",
    state: "QLD",
    remarks: "",
    postcode: "4740",
    website: "https://www.phoenixpowersports.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -21.1646728,
    long: 149.1649169,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Picton Village Mowers",
    brand: "REHLKO PETROL",
    address: "21A Bridge Street",
    phone: "(02) 4677 2597",
    fax: "",
    service: "KP",
    suburb: "Picton",
    state: "NSW",
    remarks: "",
    postcode: "2571",
    petrol: "Yes",
    diesel: "No",
    lat: -34.1892622,
    long: 150.6022922,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Pittwater Mowers",
    brand: "REHLKO PETROL",
    address: "390 Pittwater Rd",
    phone: "(02) 9939 6729",
    fax: "",
    service: "KP",
    suburb: "North Manly",
    state: "NSW",
    remarks: "",
    postcode: "2100",
    website: "https://pittwatermowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.7807531,
    long: 151.2775859,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Poole & Jackson",
    brand: "REHLKO PETROL",
    address: "11 Sunraysia Highway",
    phone: "(03) 5082 4263",
    fax: "",
    service: "KP",
    suburb: "Speed",
    state: "VIC",
    remarks: "",
    postcode: "3488",
    website: "https://www.poolenjackson.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.4020008,
    long: 142.4391766,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Port Mower Centre",
    brand: "REHLKO PETROL",
    address: "29 Jindalee Road",
    phone: "(02) 6583 3317",
    fax: "",
    service: "KP",
    suburb: "Port Macquarie",
    state: "NSW",
    remarks: "",
    postcode: "2444",
    website: "https://www.portmowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.4511519,
    long: 152.884296,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "PowerMowers",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "21-25 Glenosmond Rd",
    phone: "(08) 8272 4988",
    fax: "",
    service: "EFI|KP",
    suburb: "Eastwood",
    state: "SA",
    remarks: "",
    postcode: "5063",
    website: "https://powermowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.9420717,
    long: 138.6185263,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Preen Engineering",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "47 Forth St",
    phone: "(02) 6562 6133",
    fax: "",
    service: "EFI|KP",
    suburb: "Kempsey",
    state: "NSW",
    remarks: "",
    postcode: "2440",
    website: "https://www.preenengineering.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.0791285,
    long: 152.8432393,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Prestige Mowers",
    brand: "REHLKO PETROL",
    address: "114 Hammond Ave",
    phone: "(02) 6971 0089",
    fax: "",
    service: "KP",
    suburb: "Wagga Wagga",
    state: "NSW",
    remarks: "",
    postcode: "2650",
    website: "https://www.prestigemowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.1223026,
    long: 147.3908238,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Prompt Mowers",
    brand: "REHLKO PETROL",
    address: "295 Rooty Hill Road North",
    phone: "(02) 9832 3750",
    fax: "",
    service: "KP",
    suburb: "Plumpton",
    state: "NSW",
    remarks: "",
    postcode: "2761",
    website: "https://promptmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.7531848,
    long: 150.8401911,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Pump & Mower Supplies",
    brand: "REHLKO PETROL",
    address: "1/89 Boundry  Road",
    phone: "(07) 3287 1561",
    fax: "",
    service: "KP",
    suburb: "Beenleigh",
    state: "QLD",
    remarks: "",
    postcode: "4207",
    website: "https://www.mowerstore.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.713927,
    long: 153.1936808,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "R & A Chainsaws & Mower Supplies",
    brand: "REHLKO PETROL",
    address: "327 Main Street",
    phone: "(02) 6352 3014",
    fax: "",
    service: "KP",
    suburb: "Lithgow",
    state: "NSW",
    remarks: "",
    postcode: "2790",
    website: "https://www.facebook.com/p/RA-chainsaws-and-mowers-100067496736497/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.4832108,
    long: 150.14063,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "R & M Motorcycles",
    brand: "REHLKO PETROL",
    address: "13 Giles St",
    phone: "(08) 8972 2693",
    fax: "",
    service: "KP",
    suburb: "Katherine",
    state: "NT",
    remarks: "",
    postcode: "0850",
    website: "https://www.rmmotorcycles.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -14.4636868,
    long: 132.2649299,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Raymond Terrace Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "44 Port Stephens Street",
    phone: "(02) 4024 3032",
    fax: "",
    service: "KP",
    suburb: "Raymond Terrace",
    state: "NSW",
    remarks: "",
    postcode: "2324",
    website: "https://www.taylorsmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.7598806,
    long: 151.7436712,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Retorque Engine Reconditioning",
    brand: "REHLKO DIESEL",
    address: "29/31 Wirraway St",
    phone: "(02) 6765 7600",
    fax: "",
    service: "KD",
    suburb: "Tamworth",
    state: "NSW",
    remarks: "",
    postcode: "2340",
    website: "https://www.retorque.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -31.0928322,
    long: 150.9087596,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Richlands Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "Unit 4-5/1 Mcroyle Street",
    phone: "(07) 3271 6500",
    fax: "",
    service: "KP",
    suburb: "Wacol",
    state: "QLD",
    remarks: "",
    postcode: "4076",
    website: "https://www.mowerstore.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5977869,
    long: 152.9338715,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Rimrock Agencies Pty Ltd",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "85 Fitzroy Street",
    phone: "(07) 4927 7033",
    fax: "",
    service: "EFI|KP",
    suburb: "Rockhampton M/C",
    state: "QLD",
    remarks: "",
    postcode: "4701",
    website: "https://rimrock.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.380583,
    long: 150.5064561,
    isDieselExpert: "No",
    isPetrolExpert: "Yes",
  },
  {
    name: "Rising Sun Honda",
    brand: "REHLKO PETROL",
    address: "35 Bowen Rd",
    phone: "(07) 4779 0211",
    fax: "",
    service: "KP",
    suburb: "Hermit Park",
    state: "QLD",
    remarks: "",
    postcode: "4812",
    website: "https://www.risingsuntownsville.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -19.295055,
    long: 146.796317,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Riverstone Mower World",
    brand: "REHLKO PETROL",
    address: "42 Garfield Road",
    phone: "(02) 9838 1400",
    fax: "",
    service: "KP",
    suburb: "Riverstone",
    state: "NSW",
    remarks: "",
    postcode: "2765",
    website: "https://www.riverstonemowerworld.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.6792461,
    long: 150.862435,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Roberts Don Mac",
    brand: "REHLKO PETROL",
    address: "200 Argyle St",
    phone: "(03) 6234 4322",
    fax: "",
    service: "KP",
    suburb: "Hobart",
    state: "TAS",
    remarks: "",
    postcode: "7000",
    website: "https://www.robertsdonmac.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -42.8754621,
    long: 147.3214784,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Rocklea Diesel & Brisbane Polaris",
    brand: "REHLKO DIESEL",
    address: "1/667 Boundary Rd",
    phone: "(07) 3277 9188",
    fax: "",
    service: "KD",
    suburb: "Darra",
    state: "QLD",
    remarks: "",
    postcode: "4076",
    website: "https://www.rockleadiesel.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -27.5782536,
    long: 152.9547485,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "Roger C Brown Farm Machinery",
    brand: "REHLKO PETROL",
    address: "11-13 Hanson Street",
    phone: "(02) 6076 1788",
    fax: "",
    service: "KP",
    suburb: "Corryong",
    state: "VIC",
    remarks: "",
    postcode: "3707",
    website: "https://www.rogercbrown.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.1952759,
    long: 147.9064319,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Roma Tools & Industrial Supplies",
    brand: "REHLKO PETROL",
    address: "18-24 Hawthorne St",
    phone: "(07) 4622 7544",
    fax: "",
    service: "KP",
    suburb: "Roma",
    state: "QLD",
    remarks: "",
    postcode: "4455",
    website: "https://www.romatools.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.5701696,
    long: 148.7889579,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ron Bateman & Co",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "126 Barrack Street",
    phone: "(08) 9041 1777",
    fax: "",
    service: "KP|KD",
    suburb: "Merredin",
    state: "WA",
    remarks: "",
    postcode: "6415",
    website: "https://www.facebook.com/BatemansMerredin/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -31.4800548,
    long: 118.2896347,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Rose City Mowers",
    brand: "REHLKO PETROL",
    address: "199 Bridge Street",
    phone: "(03) 5762 4600",
    fax: "",
    service: "KP",
    suburb: "Benalla",
    state: "VIC",
    remarks: "",
    postcode: "3672",
    website: "https://rosecitymowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.548521,
    long: 145.996073,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Rosebud Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "1/8 Merino Street",
    phone: "(03) 5986 2503",
    fax: "",
    service: "KP",
    suburb: "Rosebud",
    state: "VIC",
    remarks: "",
    postcode: "3939",
    website: "https://www.rosebudmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.3854004,
    long: 144.884032,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Rosebud Saw Service",
    brand: "REHLKO PETROL",
    address: "378 Eastbourne Road",
    phone: "(03) 5986 2857",
    fax: "",
    service: "KP",
    suburb: "Rosebud",
    state: "VIC",
    remarks: "",
    postcode: "3939",
    website: "https://rosebudsawservice.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.3670476,
    long: 144.8871423,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Rosenberg Powersports",
    brand: "REHLKO PETROL",
    address: "121 William Street",
    phone: "(07) 4927 1155",
    fax: "",
    service: "KP",
    suburb: "Rockhampton M/C",
    state: "QLD",
    remarks: "",
    postcode: "4700",
    website: "https://www.rosenbergpowersports.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.383076,
    long: 150.5101535,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Russell & Sons (Qld) Pty Ltd",
    brand: "REHLKO PETROL",
    address: "18A Goggs Street",
    phone: "(07) 4688 9222",
    fax: "",
    service: "KP",
    suburb: "Toowoomba",
    state: "QLD",
    remarks: "",
    postcode: "4350",
    website: "https://www.russellandsons.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5665529,
    long: 151.9452695,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "SA Tractors",
    brand: "REHLKO DIESEL",
    address: "U12/160 Churchill Rd N",
    phone: "(08) 8349 7500",
    fax: "",
    service: "KD",
    suburb: "Cavan",
    state: "SA",
    remarks: "",
    postcode: "5094",
    website: "https://www.satractors.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -34.8308665,
    long: 138.5966992,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Sale Mowers and Chainsaws",
    brand: "REHLKO PETROL",
    address: "Shop 3/55 Princes Highway",
    phone: "(03) 5144 1513",
    fax: "",
    service: "KP",
    suburb: "Sale",
    state: "VIC",
    remarks: "",
    postcode: "3850",
    website: "https://salemowersandchainsaws.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.088738,
    long: 147.069239,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Schmidt's Mower & Chainsaw Service",
    brand: "REHLKO PETROL",
    address: "78-82 Macleod Street",
    phone: "(03) 5152 3833",
    fax: "",
    service: "KP",
    suburb: "Bairnsdale",
    state: "VIC",
    remarks: "",
    postcode: "3875",
    website: "https://schmidtsmowers.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.8271461,
    long: 147.6311437,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Sea Wasp Australia Pty Ltd",
    brand: "REHLKO DIESEL|LOMBARDINI|LOMBARDINI MARINE",
    address: "Unit 13/17 Rivergate Pl",
    phone: "(07) 3907 0708",
    fax: "",
    service: "KD|LMB|MAR",
    suburb: "Murarrie ",
    state: "QLD",
    remarks: "",
    postcode: "4172",
    website: "https://seawasp.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -27.4461321,
    long: 153.1058362,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Select Diesel Services",
    brand: "REHLKO DIESEL",
    address: "Unit 2, 10 Midas Road",
    phone: "0448 800 013",
    fax: "",
    service: "KD",
    suburb: "Malaga",
    state: "WA",
    remarks: "",
    postcode: "6090",
    website: "https://selectdieselservices.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -31.8601738,
    long: 115.8926962,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "Seville Tractors",
    brand: "REHLKO DIESEL",
    address: "51 Monbulk Seville Road",
    phone: "(03) 5964 4649",
    fax: "",
    service: "KD",
    suburb: "Seville",
    state: "VIC",
    remarks: "",
    postcode: "3139",
    website: "https://www.sevilletractors.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -37.796344,
    long: 145.4730166,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Sharp Edge Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "1/7-9 Linmax Ct",
    phone: "(03) 9042 3644",
    fax: "",
    service: "KP",
    suburb: "Point Cook",
    state: "VIC",
    remarks: "",
    postcode: "3030",
    website: "https://sharpedgerepairs.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.8742277,
    long: 144.7414651,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Sheather's Machinery Pty Ltd",
    brand: "REHLKO PETROL",
    address: "14 Dennes Street",
    phone: "(02) 6553 4507",
    fax: "",
    service: "KP",
    suburb: "Wingham",
    state: "NSW",
    remarks: "",
    postcode: "2429",
    website: "https://sheathersmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.8689838,
    long: 152.3673202,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Shepp City Garden Equipment",
    brand: "REHLKO PETROL",
    address: "42 Benalla Road",
    phone: "(03) 5821 0045",
    fax: "",
    service: "KP",
    suburb: "Shepperton",
    state: "VIC",
    remarks: "",
    postcode: "3630",
    website: "https://sheppcitygardens.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.3849586,
    long: 145.417159,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Silveys Mowers & Chainsaws",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "Units 1+2, 468 Pacific Hwy",
    phone: "(02) 4947 7150",
    fax: "",
    service: "EFI|KP",
    suburb: "Belmont",
    state: "NSW",
    remarks: "",
    postcode: "2280",
    website: "https://www.silveys.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.0312269,
    long: 151.6605427,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "SK Small Engine Services",
    brand: "REHLKO PETROL",
    address: "Unit 1/3 Newcastle Dr",
    phone: "0402 276 465",
    fax: "",
    service: "KP",
    suburb: "Toormina",
    state: "NSW",
    remarks: "",
    postcode: "2452",
    website: "https://www.sksmallengineservices.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -30.3607418,
    long: 153.0916274,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Small Engine Worx Mowers and Chainsaws",
    brand: "REHLKO PETROL",
    address: "1 Burton Road",
    phone: "(08) 9758 7882",
    fax: "",
    service: "KP",
    suburb: "Margaret River",
    state: "WA",
    remarks: "",
    postcode: "6285",
    website: "https://www.smallengineworx.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.9631624,
    long: 115.0725006,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Small Motor Service",
    brand: "REHLKO PETROL",
    address: "75 Hanson Rd",
    phone: "(07) 4972 2200",
    fax: "",
    service: "KP",
    suburb: "Gladstone Central",
    state: "QLD",
    remarks: "",
    postcode: "4680",
    website: "https://www.smallmotorservice.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.8406639,
    long: 151.2447052,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Smithton Mowers Forest & Garden",
    brand: "REHLKO PETROL",
    address: "32 Upper Havelock Street",
    phone: "(03) 6452 2624",
    fax: "",
    service: "KP",
    suburb: "Smithton",
    state: "TAS",
    remarks: "",
    postcode: "7330",
    website: "https://www.facebook.com/smithton.mowers/",
    petrol: "Yes",
    diesel: "No",
    lat: -40.8459753,
    long: 145.1254771,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "South Coast Outdoor Products",
    brand: "REHLKO PETROL",
    address: "58 Glasshouse Rocks Rd",
    phone: "(02) 4476 5075",
    fax: "",
    service: "KP",
    suburb: "Narooma",
    state: "NSW",
    remarks: "",
    postcode: "2546",
    website: "https://www.scop.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.2317406,
    long: 150.1300287,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "South Nowra Mowers & Powersports",
    brand: "REHLKO PETROL",
    address: "166A Princes Highway",
    phone: "(02) 4423 3440",
    fax: "",
    service: "KP",
    suburb: "South Nowra",
    state: "NSW",
    remarks: "",
    postcode: "2541",
    website: "https://southnowramowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.9118113,
    long: 150.6039348,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Southside Mower Centre",
    brand: "REHLKO PETROL",
    address: "4/338 Lytton Road",
    phone: "(07) 3395 1788",
    fax: "",
    service: "KP",
    suburb: "Morningside",
    state: "QLD",
    remarks: "",
    postcode: "4170",
    website: "https://www.southsidemowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.4557893,
    long: 153.0788672,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Specialised Power Equipment",
    brand: "REHLKO PETROL",
    address: "4/140-142 Brisbane Street",
    phone: "(07) 5541 0188",
    fax: "",
    service: "KP",
    suburb: "Beaudesert",
    state: "QLD",
    remarks: "",
    postcode: "4285",
    website: "https://www.facebook.com/SpecialisedPowerEquipment/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.9799669,
    long: 152.9940174,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Star Sales & Service",
    brand: "REHLKO PETROL",
    address: "58 Chester Pass Rd",
    phone: "(08) 9842 2455",
    fax: "",
    service: "KP",
    suburb: "Albany ",
    state: "WA",
    remarks: "",
    postcode: "6331",
    website: "https://starsales.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.999329,
    long: 117.870737,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stawell Lawnmower Centre",
    brand: "REHLKO PETROL",
    address: "58 Leslie St",
    phone: "(03) 5358 4668",
    fax: "",
    service: "KP",
    suburb: "Stawell",
    state: "VIC",
    remarks: "",
    postcode: "3380",
    website: "https://www.facebook.com/StawellLawnmowerCentre/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.0671597,
    long: 142.7682111,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Blayney",
    brand: "REHLKO PETROL",
    address: "5 Burns Street",
    phone: "(02) 6368 4994",
    fax: "",
    service: "KP",
    suburb: "Blayney",
    state: "NSW",
    remarks: "",
    postcode: "2799",
    website: "https://www.facebook.com/stihlshopblayney/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.5321572,
    long: 149.2561145,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Dandenong",
    brand: "REHLKO PETROL",
    address: "37/39 Cheltenham Rd",
    phone: "(03) 9792 0068",
    fax: "",
    service: "KP",
    suburb: "Dandenong South",
    state: "VIC",
    remarks: "",
    postcode: "3175",
    website: "https://stihlshopdandenong.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.9907635,
    long: 145.2089641,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Devonport",
    brand: "REHLKO PETROL",
    address: "4 Finlaysons Way",
    phone: "(03) 6424 1199",
    fax: "",
    service: "KP",
    suburb: "Devonport",
    state: "TAS",
    remarks: "",
    postcode: "7310",
    website: "https://www.facebook.com/StihlShopDevonport/",
    petrol: "Yes",
    diesel: "No",
    lat: -41.1897705,
    long: 146.362265,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Echuca",
    brand: "REHLKO PETROL",
    address: "47 Ogilvie Avenue",
    phone: "(03) 5480 9566",
    fax: "",
    service: "KP",
    suburb: "Echuca",
    state: "VIC",
    remarks: "",
    postcode: "3564",
    website: "https://www.facebook.com/p/Stihl-Shop-Echuca-100039871526857/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.1410279,
    long: 144.7673352,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Esk",
    brand: "REHLKO PETROL",
    address: "239 Ipswich Street",
    phone: "(07) 5424 1605",
    fax: "",
    service: "KP",
    suburb: "Esk",
    state: "QLD",
    remarks: "",
    postcode: "4312",
    website: "https://www.stihlshopesk.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.2357303,
    long: 152.4187391,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Ferntree Gully",
    brand: "REHLKO PETROL",
    address: "1140 Burwood Hwy",
    phone: "(03) 9752 2218",
    fax: "",
    service: "KP",
    suburb: "Ferntree Gully",
    state: "VIC",
    remarks: "",
    postcode: "3156",
    website: "https://www.facebook.com/stihlshopftg/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.8907725,
    long: 145.2996092,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Fulham",
    brand: "REHLKO PETROL",
    address: "Shop 1,587-589 Tapleys Hill Rd",
    phone: "(08) 8353 1505",
    fax: "",
    service: "KP",
    suburb: "Fulham",
    state: "SA",
    remarks: "",
    postcode: "5024",
    website: "https://www.stihlshopfulham.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.9281812,
    long: 138.5181368,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Garbutt",
    brand: "REHLKO PETROL",
    address: "56 Pilkington St",
    phone: "(07) 4779 8733",
    fax: "",
    service: "KP",
    suburb: "Garbutt ",
    state: "QLD",
    remarks: "",
    postcode: "4814",
    website: "https://stihlshopstownsville.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -19.271896,
    long: 146.7675056,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Geelong",
    brand: "REHLKO PETROL",
    address: "137 Fyans Street",
    phone: "(03) 5229 3924",
    fax: "",
    service: "KP",
    suburb: "South Geelong",
    state: "VIC",
    remarks: "",
    postcode: "3220",
    website: "https://www.geelongmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.1641867,
    long: 144.3640067,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Grafton",
    brand: "REHLKO PETROL",
    address: "131 Prince Street",
    phone: "(02) 6642 2386",
    fax: "",
    service: "KP",
    suburb: "Grafton",
    state: "NSW",
    remarks: "",
    postcode: "2460",
    website: "https://www.stihlshopgrafton.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -29.687965,
    long: 152.935487,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Huonville",
    brand: "REHLKO PETROL",
    address: "14 Wilmot Road",
    phone: "(03) 6264 1671",
    fax: "",
    service: "KP",
    suburb: "Huonville",
    state: "TAS",
    remarks: "",
    postcode: "7109",
    website: "https://stihlshophuonville.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -43.0299632,
    long: 147.0480213,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Londonderry ",
    brand: "REHLKO PETROL",
    address: "512 Londonderry Rd",
    phone: "(02) 4578 8800",
    fax: "",
    service: "KP",
    suburb: "Londonderry",
    state: "NSW",
    remarks: "",
    postcode: "2753",
    website: "https://www.facebook.com/StihlShopLondonderry/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.6448023,
    long: 150.7354393,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Mildura",
    brand: "REHLKO PETROL",
    address: "637 Fifteenth Street",
    phone: "(03) 5022 2840",
    fax: "",
    service: "KP",
    suburb: "Mildura",
    state: "VIC",
    remarks: "",
    postcode: "3500",
    website: "https://www.stihlshopmildura.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.2185599,
    long: 142.1512756,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Nambour",
    brand: "REHLKO PETROL",
    address: "29 Coronation Avenue",
    phone: "(07) 5441 2382",
    fax: "",
    service: "KP",
    suburb: "Nambour",
    state: "QLD",
    remarks: "",
    postcode: "4560",
    website: "https://stihlshopnambour.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.6213649,
    long: 152.9629065,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Payneham",
    brand: "REHLKO PETROL",
    address: "388 Payneham Rd",
    phone: "(08) 8165 2222",
    fax: "",
    service: "KP",
    suburb: "Payneham",
    state: "SA",
    remarks: "",
    postcode: "5070",
    website: "https://www.facebook.com/stihlshoppayneham/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.8944305,
    long: 138.6445042,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Port Macquarie",
    brand: "REHLKO PETROL",
    address: "5 Milton Circuit",
    phone: "(02) 6581 0301",
    fax: "",
    service: "KP",
    suburb: "Port Macquaire",
    state: "NSW",
    remarks: "",
    postcode: "2444",
    website: "https://www.stihlshopportmacquarie.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.4469098,
    long: 152.892595,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stihl Shop Swan Hill",
    brand: "REHLKO PETROL",
    address: "27-33 Nyah Road",
    phone: "(03) 5032 2594",
    fax: "",
    service: "KP",
    suburb: "Swan Hill",
    state: "VIC",
    remarks: "",
    postcode: "3585",
    website: "https://stihlshopswanhill.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.3290976,
    long: 143.5543418,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stirling Equipment Hire Company",
    brand: "REHLKO PETROL",
    address: "84 Mount Barker Rd",
    phone: "(08) 8339 4500",
    fax: "",
    service: "KP",
    suburb: "Stirling",
    state: "SA",
    remarks: "",
    postcode: "5152",
    website: "https://stirlinghire.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.0080846,
    long: 138.7218686,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Stockers & Partridge",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "38 Maitland Road",
    phone: "(02) 4938 5154",
    fax: "",
    service: "KP|KD",
    suburb: "Paterson",
    state: "NSW",
    remarks: "",
    postcode: "2421",
    website: "https://www.stockerspartridge.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -32.6048581,
    long: 151.6165071,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Strathalbyn Small Engines",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "51 Murray St",
    phone: "(08) 8536 3505",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Strathalbyn",
    state: "SA",
    remarks: "",
    postcode: "5255",
    website: "https://www.strathalbynsmallengines.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -35.2581672,
    long: 138.896111,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "Suburban Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "214 Fifteenth Avenue",
    phone: "(02) 9826 0188",
    fax: "",
    service: "KP",
    suburb: "West Hoxton",
    state: "NSW",
    remarks: "",
    postcode: "2171",
    website: "https://suburbanope.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.9212342,
    long: 150.8308345,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Sunraysia Mower Centre",
    brand: "REHLKO PETROL",
    address: "60 Orange Avenue",
    phone: "(03) 5023 5745",
    fax: "",
    service: "KP",
    suburb: "Mildura",
    state: "VIC",
    remarks: "",
    postcode: "3500",
    website: "https://sunraysiamowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.1875083,
    long: 142.1644818,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Sunshine Coast Mowers",
    brand: "REHLKO PETROL",
    address: "189 Brisbane Road",
    phone: "(07) 5444 2577",
    fax: "",
    service: "KP",
    suburb: "Mooloolaba",
    state: "QLD",
    remarks: "",
    postcode: "4557",
    website: "https://sunshinecoastmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.6933448,
    long: 153.1153843,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Sydney Diesel Centre Pty Ltd",
    brand: "REHLKO DIESEL",
    address: "126 Warren Road",
    phone: "(02) 9681 7700",
    fax: "",
    service: "KD",
    suburb: "Smithfield",
    state: "NSW",
    remarks: "",
    postcode: "2164",
    website: "https://www.sydneydieselcentre.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -33.8459354,
    long: 150.953544,
    isDieselExpert: "Yes",
    isPetrolExpert: "No",
  },
  {
    name: "SYP Motors",
    brand: "REHLKO PETROL",
    address: "9 Main Street",
    phone: "(08) 8853 2018",
    fax: "",
    service: "KP",
    suburb: "Minlaton",
    state: "SA",
    remarks: "",
    postcode: "5575",
    website: "https://www.sypmotors.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.7693507,
    long: 137.5961377,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tableland Pumps Pipes & Rural",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "40-46 Eclipse Drive",
    phone: "(07) 4091 2277",
    fax: "",
    service: "KP|KD",
    suburb: "Atherton",
    state: "QLD",
    remarks: "",
    postcode: "4883",
    website: "https://www.tpprural.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -17.256021,
    long: 145.4747762,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tamworth Chainsaw & Mower Centre",
    brand: "REHLKO PETROL",
    address: "205 Peel Street",
    phone: "(02) 6766 4337",
    fax: "",
    service: "KP",
    suburb: "Tamworth",
    state: "NSW",
    remarks: "",
    postcode: "2340",
    website: "https://tamworthchainsaws.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.0876309,
    long: 150.92655,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tamworth Motorcycle Repairs",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "1/22 Macintosh St",
    phone: "0474 826 359",
    fax: "",
    service: "KP|KD",
    suburb: "Tamworth",
    state: "NSW",
    remarks: "",
    postcode: "2340",
    website: "https://www.facebook.com/p/Tamworth-Motorcycle-Repairs-100064645878007/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -31.0963472,
    long: 150.9014134,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tamworth Small Engines",
    brand: "REHLKO PETROL",
    address: "25 Crown St",
    phone: "(02) 6765 9737",
    fax: "",
    service: "KP",
    suburb: "West Tamworth",
    state: "NSW",
    remarks: "",
    postcode: "2340",
    website: "https://www.tamworthsmallengines.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.0883549,
    long: 150.9167078,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tannum Mower Centre",
    brand: "REHLKO PETROL",
    address: "21 Steel Street",
    phone: "(07) 4973 9895",
    fax: "",
    service: "KP",
    suburb: "Tannum Sands",
    state: "QLD",
    remarks: "",
    postcode: "4680",
    website: "https://www.tannummower.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.9545522,
    long: 151.3715838,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tas Mini Motor Service",
    brand: "REHLKO PETROL",
    address: "71 Alfred Street",
    phone: "(07) 4654 1732",
    fax: "",
    service: "KP",
    suburb: "Charleville",
    state: "QLD",
    remarks: "",
    postcode: "4470",
    website: "https://www.facebook.com/tasminimotors/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.4006843,
    long: 146.2398058,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Taylor's Outdoor Power Equipment",
    brand: "REHLKO PETROL",
    address: "59-61 Broadmeadow Road",
    phone: "(02) 4952 9966",
    fax: "",
    service: "KP",
    suburb: "Broadmeadow",
    state: "NSW",
    remarks: "",
    postcode: "2292",
    website: "https://www.taylorsmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.9149845,
    long: 151.7329089,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Terrence's Oversnow & Atv Sales & Services",
    brand: "REHLKO PETROL",
    address: "2 Baggs St",
    phone: "(02) 6456 2222",
    fax: "",
    service: "KP",
    suburb: "Jindabyne",
    state: "NSW",
    remarks: "",
    postcode: "2627",
    petrol: "Yes",
    diesel: "No",
    lat: -36.4365899,
    long: 148.603061,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "The Big Mower Winnellie",
    brand: "REHLKO PETROL",
    address: "3 Lee St",
    phone: "(08) 8947 2244",
    fax: "",
    service: "KP",
    suburb: "Winnellie",
    state: "NT",
    remarks: "",
    postcode: "0820",
    website: "https://thebigmower.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -12.4259983,
    long: 130.8868883,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "The Bike And Brew",
    brand: "REHLKO PETROL",
    address: "170 Ferry Street",
    phone: "(07) 4121 6630",
    fax: "",
    service: "KP",
    suburb: "Maryborough",
    state: "QLD",
    remarks: "",
    postcode: "4650",
    website: "https://www.thebikeandbrew.com.au/home",
    petrol: "Yes",
    diesel: "No",
    lat: -25.5304132,
    long: 152.6998657,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "The Brown & Hurley Group",
    brand: "REHLKO DIESEL",
    address: "2 Central Park Dr",
    phone: "(07) 4940 7300",
    fax: "",
    service: "KD",
    suburb: "Paget ",
    state: "QLD",
    remarks: "",
    postcode: "4740",
    website: "https://www.brownandhurley.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -21.1755649,
    long: 149.1661223,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "The Garden Shed",
    brand: "REHLKO PETROL",
    address: "279 Morayfield Road",
    phone: "(07) 5497 8844",
    fax: "",
    service: "KP",
    suburb: "Morayfield",
    state: "QLD",
    remarks: "",
    postcode: "4506",
    website: "https://stihlshopmorayfield.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.1128702,
    long: 152.9518291,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "The Mower Supastore",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "1/245 Leitchs Road",
    phone: "(07) 3205 1299",
    fax: "",
    service: "EFI|KP",
    suburb: "Brendale",
    state: "QLD",
    remarks: "",
    postcode: "4500",
    website: "https://mowersupastore.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.3170364,
    long: 152.9817225,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "The Rural Centre",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "154 Lords Place",
    phone: "(02) 6362 1899",
    fax: "",
    service: "KP|KD",
    suburb: "Orange",
    state: "NSW",
    remarks: "",
    postcode: "2800",
    website: "https://ruralcentre.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -33.2865143,
    long: 149.1010184,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "The Saw Spot",
    brand: "REHLKO PETROL",
    address: "54 Summerland Way",
    phone: "(02) 6632 3600",
    fax: "",
    service: "KP",
    suburb: "Kyogle",
    state: "NSW",
    remarks: "",
    postcode: "2474",
    website: "https://www.thesawspot.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.6195852,
    long: 153.0041294,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Think Water Alice Springs",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "43 Elder St",
    phone: "(08) 8952 1844",
    fax: "",
    service: "KP|KD",
    suburb: "Ciccone ",
    state: "NT",
    remarks: "",
    postcode: "0870",
    website: "https://www.thinkwater.com.au/alicesprings/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -23.6958685,
    long: 133.8661397,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Think Water Peats Ridge",
    brand: "REHLKO PETROL",
    address: "780 Peats Ridge Rd",
    phone: "(02) 4373 1466",
    fax: "",
    service: "KP",
    suburb: "Peats Ridge",
    state: "NSW",
    remarks: "",
    postcode: "2250",
    website: "https://www.thinkwatercentralcoast.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.3162016,
    long: 151.2354349,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tink’s - Newcastle",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "2 / 52 Riverside Drive",
    phone: "(02) 4961 1332",
    fax: "",
    service: "KP|KD",
    suburb: "Mayfield West",
    state: "NSW",
    remarks: "",
    postcode: "2304",
    website: "https://www.tinks.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -32.8747428,
    long: 151.7178894,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tom's Small Engines",
    brand: "REHLKO PETROL",
    address: "36 Alma Street",
    phone: "(03) 5495 1773",
    fax: "",
    service: "KP",
    suburb: "St Arnauds",
    state: "VIC",
    remarks: "",
    postcode: "3478",
    website: "https://tomssmallengines.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.614766,
    long: 143.2540362,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Toowoomba Mower Centre",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "3 Sowden Street",
    phone: "(07) 4630 2150",
    fax: "",
    service: "EFI|KP",
    suburb: "Toowoomba",
    state: "QLD",
    remarks: "",
    postcode: "4350",
    website: "https://toowoombamowercentre.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5897128,
    long: 151.9206992,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Toowoomba Outdoor Power Products",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: " 22 Rocla Ct",
    phone: "(07) 4632 8455",
    fax: "",
    service: "EFI|KP",
    suburb: "Glenvale",
    state: "QLD",
    remarks: "",
    postcode: "4350",
    website: "https://topp.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.55421,
    long: 151.9088102,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Towers Power Equipment",
    brand: "REHLKO PETROL",
    address: "125 Gill Street",
    phone: "(07) 4787 1923",
    fax: "",
    service: "KP",
    suburb: "Charters Towers",
    state: "QLD",
    remarks: "",
    postcode: "4820",
    website: "https://www.facebook.com/www.towerspe.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -20.0764194,
    long: 146.2627048,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Town & Country Equipment Centre",
    brand: "REHLKO PETROL",
    address: "18 Sydney Road",
    phone: "(02) 6372 2402",
    fax: "",
    service: "KP",
    suburb: "Mudgee",
    state: "NSW",
    remarks: "",
    postcode: "2850",
    website: "https://www.towncountry.shop/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.6050539,
    long: 149.5982547,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "T-Quip",
    brand: "EFI SOFTWARE|REHLKO PETROL",
    address: "36 Abernethy Rd",
    phone: "(08) 9478 7000",
    fax: "",
    service: "EFI|KP",
    suburb: "Belmont",
    state: "WA",
    remarks: "",
    postcode: "6984",
    website: "https://www.tquip.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.9492031,
    long: 115.9200998,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tracpower NQ",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "101 Ingham Road",
    phone: "(07) 4772 6455",
    fax: "",
    service: "EFI|KP|KD",
    suburb: "Townsville ",
    state: "QLD",
    remarks: "",
    postcode: "4810",
    website: "https://www.tracpower.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -19.267557,
    long: 146.7974296,
    isDieselExpert: "Yes",
    isPetrolExpert: "Yes",
  },
  {
    name: "Traction Ag Pty Ltd",
    brand: "REHLKO PETROL",
    address: "45 Sea Lake-Swan Hill Road",
    phone: "(03) 5033 2416",
    fax: "",
    service: "KP",
    suburb: "Swan Hill",
    state: "VIC",
    remarks: "",
    postcode: "3585",
    website: "https://www.tractionag.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.3415502,
    long: 143.536711,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tumbi Mowers",
    brand: "REHLKO PETROL",
    address: "39 Wyong Road",
    phone: "0408 806 077",
    fax: "",
    service: "KP",
    suburb: "Tumbi Umbi",
    state: "NSW",
    remarks: "",
    postcode: "2261",
    website: "https://tumbioutdoorpower.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.3623741,
    long: 151.4468273,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Tumut Outdoor Power Centre",
    brand: "REHLKO PETROL",
    address: "34 Adelong Road",
    phone: "(02) 6947 2510",
    fax: "",
    service: "KP",
    suburb: "Tumut",
    state: "NSW",
    remarks: "",
    postcode: "2720",
    website: "https://outdoorpowercentre.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.2959795,
    long: 148.2147305,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ulladulla Mowers",
    brand: "REHLKO PETROL",
    address: "2/213 Princes Hwy",
    phone: "(02) 4455 1007",
    fax: "",
    service: "KP",
    suburb: "Ulladulla",
    state: "NSW",
    remarks: "",
    postcode: "2539",
    website: "https://ulladullamowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.3672879,
    long: 150.4696379,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ultimate Welder & Power Tool Repairs",
    brand: "REHLKO PETROL",
    address: "4 Tait St",
    phone: "(07) 4634 4216",
    fax: "",
    service: "KP",
    suburb: "Torrington",
    state: "QLD",
    remarks: "",
    postcode: "4350",
    website: "https://www.ultimatewelderandpowertoolrepairs.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5558494,
    long: 151.9005126,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Ulverstone Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "1 Killowatt Court",
    phone: "(03) 6425 4159",
    fax: "",
    service: "KP",
    suburb: "Ulverstone",
    state: "TAS",
    remarks: "",
    postcode: "7315",
    website: "https://ulverstonemowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -41.1576542,
    long: 146.2057377,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Unanderra Mower Centre",
    brand: "REHLKO PETROL",
    address: "51 Princes Highway",
    phone: "(02) 4271 1340",
    fax: "",
    service: "KP",
    suburb: "Unanderra",
    state: "NSW",
    remarks: "",
    postcode: "2526",
    website: "https://www.unanderramowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.4510767,
    long: 150.8485387,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Upper Burnie Mowers",
    brand: "REHLKO PETROL",
    address: "183 Mount St",
    phone: "(03) 6431 9188",
    fax: "",
    service: "KP",
    suburb: "Burnie",
    state: "TAS",
    remarks: "",
    postcode: "7320",
    website: "https://upperburniemowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -41.0688277,
    long: 145.9014627,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Valley Outdoors Group",
    brand: "REHLKO PETROL",
    address: "100 Liverpool St",
    phone: "(02) 6545 3033",
    fax: "",
    service: "KP",
    suburb: "Scone",
    state: "NSW",
    remarks: "",
    postcode: "2337",
    website: "https://valleyoutdoorsgroup.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.0501208,
    long: 150.8648861,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Valley Power Equipment",
    brand: "EFI SOFTWARE|REHLKO PETROL|REHLKO DIESEL",
    address: "70 Basedow Road",
    phone: "(08) 8563 3575",
    fax: "",
    service: "EFI|KP",
    suburb: "Tanunda",
    state: "SA",
    remarks: "",
    postcode: "5352",
    website: "https://valleypowerequipment.husqvarnadealers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.5262373,
    long: 138.9683876,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Victoria Point Mower Centre",
    brand: "REHLKO PETROL",
    address: "Shop K.02, 21-27 Bunker Road",
    phone: "(07) 3207 0122",
    fax: "",
    service: "KP",
    suburb: "Victoria Point",
    state: "QLD",
    remarks: "",
    postcode: "4165",
    petrol: "Yes",
    diesel: "No",
    lat: 27.5865189,
    long: 153.2785165,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Village Mowers and Power Tools",
    brand: "REHLKO PETROL",
    address: "2A Memorial Ave",
    phone: "(02) 9605 1100",
    fax: "",
    service: "KP",
    suburb: "Ingleburn ",
    state: "NSW",
    remarks: "",
    postcode: "2565",
    website: "https://villagemowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.9965161,
    long: 150.8635935,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Vin Rowe Farm Machinery",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "3 Endeavour St",
    phone: "(03) 5622 9100",
    fax: "",
    service: "KP|KD",
    suburb: "Warragul",
    state: "VIC",
    remarks: "",
    postcode: "3820",
    website: "https://www.vinrowe.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -38.1681358,
    long: 145.9415451,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Vince Strang Motorcycles and Power Equipment",
    brand: "REHLKO PETROL",
    address: "259 Byron St",
    phone: "(02) 6721 0610",
    fax: "",
    service: "KP",
    suburb: "Inverell",
    state: "NSW",
    remarks: "",
    postcode: "2360",
    website: "https://vincestrangmotorcycles.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -29.7683213,
    long: 151.1200821,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Wangaratta Pump Shop",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "71 Greta Rd",
    phone: "(03) 5722 1955",
    fax: "",
    service: "KP|KD",
    suburb: "Wangaratta",
    state: "VIC",
    remarks: "",
    postcode: "3677",
    website: "https://wangarattapumpshop.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -36.3697092,
    long: 146.3141674,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Wangaratta Saw & Lawnmower Service",
    brand: "REHLKO PETROL",
    address: "149 Vincent Road",
    phone: "(03) 5721 3310",
    fax: "",
    service: "KP",
    suburb: "Wangaratta",
    state: "VIC",
    remarks: "",
    postcode: "3677",
    website: "https://www.wangarattasaw.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.3642609,
    long: 146.3056478,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Warwick Small Engines and Mowers",
    brand: "REHLKO PETROL",
    address: "105 McEvoy Street",
    phone: "(07) 4514 6069",
    fax: "",
    service: "KP",
    suburb: "Warwick",
    state: "QLD",
    remarks: "",
    postcode: "4370",
    website: "https://www.warwicksmallengines.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.2310336,
    long: 152.0379954,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Wauchope Tyre & Mower",
    brand: "REHLKO PETROL",
    address: "60 Randall Street",
    phone: "(02) 6585 2053",
    fax: "",
    service: "KP",
    suburb: "Wauchope",
    state: "NSW",
    remarks: "",
    postcode: "2446",
    website: "https://www.wauchopetyreandmower.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -31.4580286,
    long: 152.7369738,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "West Coast Power Equipment",
    brand: "REHLKO PETROL",
    address: "6 Husband Road",
    phone: "(08) 9535 9996",
    fax: "",
    service: "KP",
    suburb: "Barragup",
    state: "WA",
    remarks: "",
    postcode: "6209",
    website: "https://westcoastpowerequipment.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.5488237,
    long: 115.7755631,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Westco Equipment",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "14 Clapham St",
    phone: "(08) 9258 9333",
    fax: "",
    service: "KP|KD",
    suburb: "Beckenham ",
    state: "WA",
    remarks: "",
    postcode: "6107",
    website: "https://westcoequipment.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -32.0266339,
    long: 115.9527588,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Western Mowers",
    brand: "REHLKO PETROL",
    address: "2274 Moggill Road",
    phone: "(07) 3568 4610",
    fax: "",
    service: "KP",
    suburb: "Kenmore",
    state: "QLD",
    remarks: "",
    postcode: "4069",
    website: "https://www.westernmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.5173932,
    long: 152.9239436,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Western Mowers & Chainsaws",
    brand: "REHLKO PETROL",
    address: "3 Toongabbie Rd",
    phone: "(02) 9631 1696",
    fax: "",
    service: "KP",
    suburb: "Toongabbie",
    state: "NSW",
    remarks: "",
    postcode: "2146",
    website: "https://mowersandchainsaws.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.7885302,
    long: 150.9506888,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Whitsunday Mowers",
    brand: "REHLKO PETROL",
    address: "31 Chapman Street",
    phone: "(07) 4945 1999",
    fax: "",
    service: "KP",
    suburb: "Proserpine",
    state: "QLD",
    remarks: "",
    postcode: "4800",
    website: "https://www.whitsundaymowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -20.4031205,
    long: 148.5833071,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Wiggies Pty Ltd",
    brand: "REHLKO PETROL",
    address: "17 Dawson Street",
    phone: "(03) 5144 4441",
    fax: "",
    service: "KP",
    suburb: "Sale",
    state: "VIC",
    remarks: "",
    postcode: "3850",
    website: "https://brownwigg.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.0921585,
    long: 147.0607859,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Wimmera Ag & Equipment",
    brand: "REHLKO PETROL",
    address: "92 Commercial Street",
    phone: "(03) 5392 2722",
    fax: "",
    service: "KP",
    suburb: "Kaniva",
    state: "VIC",
    remarks: "",
    postcode: "3419",
    website: "https://www.facebook.com/p/Wimmera-Ag-Equipment-Pty-Ltd-100063713823011/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.3793113,
    long: 141.2415098,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Windsor Farm Equipment Pty Ltd",
    brand: "REHLKO PETROL",
    address: "429 Windsor Rd",
    phone: "(02) 4577 3613",
    fax: "",
    service: "KP",
    suburb: "Vineyard",
    state: "NSW",
    remarks: "",
    postcode: "2765",
    website: "https://www.windsorfarmequipment.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.6389201,
    long: 150.8509975,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Wonthaggi Motorcycles and Power Equipment",
    brand: "REHLKO PETROL",
    address: "48-52 Inverloch Road",
    phone: "(03) 5672 3500",
    fax: "",
    service: "KP",
    suburb: "Wonthaggi",
    state: "VIC",
    remarks: "",
    postcode: "3995",
    website: "https://www.wonthaggimotorcycles.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.6077933,
    long: 145.605933,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "WSB Distributors",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "198 Main N Rd",
    phone: "1300 000 972",
    fax: "",
    service: "KP",
    suburb: "Clare",
    state: "SA",
    remarks: "",
    postcode: "5453",
    website: "https://www.wsb.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.8353911,
    long: 138.6134798,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Yardworx Equipment Ltd",
    brand: "REHLKO PETROL",
    address: "59 Beerburrum Rd",
    phone: "(07) 5495 4720",
    fax: "",
    service: "KP",
    suburb: "Caboolture",
    state: "QLD",
    remarks: "",
    postcode: "4510",
    website: "https://www.yardworx.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.0779156,
    long: 152.9511807,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Yarra Valley Ag",
    brand: "REHLKO PETROL",
    address: "439 Maroondah Hwy",
    phone: "(03) 9735 5233",
    fax: "",
    service: "KP",
    suburb: "Lilydale",
    state: "VIC",
    remarks: "",
    postcode: "3140",
    website: "https://www.yarravalleyag.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.755285,
    long: 145.360193,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Yass Outdoor Power Centre",
    brand: "REHLKO PETROL",
    address: "230 Comur Street",
    phone: "(02) 6226 1648",
    fax: "",
    service: "KP",
    suburb: "Yass",
    state: "NSW",
    remarks: "",
    postcode: "2582",
    website: "https://www.yopc.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -34.8447802,
    long: 148.9140477,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Yatala Small Engines",
    brand: "REHLKO PETROL",
    address: "535 Stanmore Road",
    phone: "(07) 5546 4461",
    fax: "",
    service: "KP",
    suburb: "Luscombe",
    state: "QLD",
    remarks: "",
    postcode: "4207",
    petrol: "Yes",
    diesel: "No",
    lat: -27.7745655,
    long: 153.1987202,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Yea Machinery",
    brand: "REHLKO PETROL",
    address: "6 Station Street",
    phone: "(03) 9730 1988",
    fax: "",
    service: "KP",
    suburb: "Yea",
    state: "VIC",
    remarks: "",
    postcode: "3717",
    website: "https://yeamachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.2129967,
    long: 145.426426,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Yeppoon Small Motor Service",
    brand: "REHLKO PETROL",
    address: "56 Tanby Road",
    phone: "(07) 4939 2115",
    fax: "",
    service: "KP",
    suburb: "Yeppoon",
    state: "QLD",
    remarks: "",
    postcode: "4703",
    website: "https://ysms.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.1380087,
    long: 150.738495,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "Zac Zanesco Motorcycles",
    brand: "REHLKO PETROL",
    address: "58-60 Banna Ave",
    phone: "(02) 6964 7928",
    fax: "",
    service: "KP",
    suburb: "Griffith",
    state: "NSW",
    remarks: "",
    postcode: "2680",
    website: "https://zacsmc.com.au/home",
    petrol: "Yes",
    diesel: "No",
    lat: -34.2900032,
    long: 146.0567409,
    isDieselExpert: "No",
    isPetrolExpert: "No",
  },
  {
    name: "RMG Industrial",
    brand: "REHLKO DIESEL",
    address: "1 Hatcher Court",
    phone: "(08) 8281 2508",
    fax: "",
    service: "KD",
    suburb: "Burton",
    state: "SA",
    remarks: "",
    postcode: "5110",
    website: "https://www.rmgindustrial.com.au/",
    petrol: "No",
    diesel: "Yes",
    lat: -34.7354941,
    long: 138.5842876,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
  name: "South Coast Small Engines",
  brand: "REHLKO DIESEL",
  address: "21 Commerce Cres",
  phone: "0421 601 297",
  fax: "",
  service: "KD",
  suburb: "Hindmarsh Valley",
  state: "SA",
  remarks: "",
  postcode: "5211",
  website: "https://www.facebook.com/SouthCoastSmallEngines/",
  petrol: "No",
  diesel: "Yes",
  lat: -35.5234726,
  long: 138.6480578,
  isDieselExpert: "No",
  isPetrolExpert: "No"
},
{
  name: "South Coast Small Engines",
  brand: "REHLKO PETROL",
  address: "21 Commerce Cres",
  phone: "0421 601 297",
  fax: "",
  service: "KD",
  suburb: "Hindmarsh Valley",
  state: "SA",
  remarks: "",
  postcode: "5211",
  website: "https://www.facebook.com/SouthCoastSmallEngines/",
  petrol: "Yes",
  diesel: "No",
  lat: -35.5234726,
  long: 138.6480578,
  isDieselExpert: "No",
  isPetrolExpert: "No"
},
{
  name: "Powerplant Motorcycles",
  brand: "REHLKO PETROL",
  address: "51 Norseman Rd",
  phone: "(08) 9071 1780",
  fax: "",
  service: "KP",
  suburb: "Chadwick",
  state: "WA",
  remarks: "",
  postcode: "6450",
  website: "https://www.powerplantmotorcycles.com.au/",
  petrol: "Yes",
  diesel: "No",
  lat: -33.837686,
  long: 121.8996926,
  isDieselExpert: "No",
  isPetrolExpert: "No",
},
{
  name: "Clarke Diesel",
  brand: "REHLKO PETROL|REHLKO DIESEL",
  address: "141 Lyons St, Bungalow",
  phone: "(07) 4031 9000",
  fax: "",
  service: "KP|KD",
  suburb: "Cairns",
  state: "QLD",
  remarks: "",
  postcode: "4870",
  website: "https://clarkediesel.com.au",
  petrol: "Yes",
  diesel: "Yes",
  lat: -16.9396777007087,
  long: 145.755668912056,
  isDieselExpert: "No",
  isPetrolExpert: "No",
},
{
  name: "Mountain Mowers",
  brand: "REHLKO PETROL",
  address: "6/6 Lawyer Street",
  phone: "(07) 5494 3172",
  fax: "",
  service: "KP",
  suburb: "MALENY",
  state: "QLD",
  remarks: "",
  postcode: "4552",
  website: "https://www.facebook.com/malenyqld/",
  petrol: "Yes",
  diesel: "No",
  lat: -26.7606121431634,
  long: 152.854077039262,
  isDieselExpert: "No",
  isPetrolExpert: "No",
},
{
  name: "URUNGA CHAINSAW AND MOWER",
  brand: "REHLKO PETROL",
  address: "Lot 1, Marina Cres",
  phone: "(02) 6655 6411",
  fax: "",
  service: "KP",
  suburb: "URUNGA",
  state: "NSW",
  remarks: "",
  postcode: "2455",
  website: "https://www.urungachainsawandmower.com.au/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
  petrol: "Yes",
  diesel: "No",
  lat: -30.4871446468264,
  long: 153.008417168208,
  isDieselExpert: "No",
  isPetrolExpert: "No",
},
{
    name: "VEDELAGO MECHANICAL REPAIRS",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "12 Vedelago Lane",
    phone: "(07) 4685 2200",
    fax: "",
    service: "KP|KD",
    suburb: "THULIMBAH",
    state: "QLD ",
    remarks: "",
    postcode: "4376",
    website: "https://www.vedelagomechanicalrepairs.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -28.5407584503853,
    long: 151.914882895131,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "KARL'S MOWERS",
    brand: "REHLKO PETROL",
    address: "Unit 1/1 Flint Court",
    phone: "(07) 5593 4899",
    fax: "",
    service: "KP",
    suburb: "VARSITY LAKES",
    state: "QLD",
    remarks: "",
    postcode: "4227",
    website: "http://www.karlsmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -28.1005315573082,
    long: 153.412623710464,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "A.C.T Small Engine Specialists",
    brand: "REHLKO PETROL",
    address: "Unit 1/30 Raws Cres",
    phone: "(02) 6260 1828",
    fax: "",
    service: "KP",
    suburb: "Hume",
    state: "ACT",
    remarks: "",
    postcode: "2620",
    website: "http://www.actsmallenginespecialists.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.3934847973519,
    long: 149.16732724139,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "TOPSHELF TOOLS AUSTRALIA",
    brand: "REHLKO PETROL",
    address: "Unit 10/143-155 Bonds Road",
    phone: "0415 918 228",
    fax: "",
    service: "KP",
    suburb: "RIVERWOOD",
    state: "NSW",
    remarks: "",
    postcode: "2210",
    website: "https://www.topshelftools.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.9399008493421,
    long: 151.05929205483,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "SWAN HILL SMALL ENGINES",
    brand: "REHLKO PETROL",
    address: "83 Karinie Street",
    phone: "(03) 5048 6122",
    fax: "",
    service: "KP",
    suburb: "SWAN HILL",
    state: "VIC",
    remarks: "",
    postcode: "3585",
    website: "https://www.facebook.com/p/Swan-Hill-Small-Engines-61581101101729/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.327078217071,
    long: 143.552450225406,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "WARRNAMBOOL GARDEN EQUIPMENT",
    brand: "REHLKO PETROL",
    address: "2 Braithwaite Street",
    phone: "(03) 4520 9309",
    fax: "",
    service: "KP",
    suburb: "WARRNAMBOOL",
    state: "VIC",
    remarks: "",
    postcode: "3280",
    website: "http://wge.net.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.3699238513229,
    long: 142.460125214518,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "PHOENIX OUTDOOR AND POWER",
    brand: "REHLKO PETROL",
    address: "249 John Street",
    phone: "(02) 6572 4622",
    fax: "",
    service: "KP",
    suburb: "SINGLETON",
    state: "NSW",
    remarks: "",
    postcode: "2330",
    website: "https://phoenixoutdoor.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -32.5597742370067,
    long: 151.17271788362,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "MORTLAKE MOTORCYCLE & MOWER",
    brand: "REHLKO PETROL",
    address: "65 Dunlop St",
    phone: "0481 265 266",
    fax: "",
    service: "KP",
    suburb: "MORTLAKE",
    state: "VIC",
    remarks: "",
    postcode: "3272",
    website: "https://www.facebook.com/p/Mortlake-Motorcycles-and-Mowers-100072089191702/",
    petrol: "Yes",
    diesel: "No",
    lat: -38.0807488442017,
    long: 142.804055848907,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "Southbound Agencies",
    brand: "REHLKO PETROL",
    address: "34 Toolooa St",
    phone: "(07) 4972 3515",
    fax: "",
    service: "KP",
    suburb: "GLADSTONE",
    state: "QLD",
    remarks: "",
    postcode: "4680",
    website: "https://www.facebook.com/southboundagencies/",
    petrol: "Yes",
    diesel: "No",
    lat: -23.84909477309,
    long: 151.26568640984,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "MOWER MART SAMFORD",
    brand: "REHLKO PETROL",
    address: "6/220 Mount Glorious Rd",
    phone: "(07) 3289 2060",
    fax: "",
    service: "KP",
    suburb: "SAMFORD VALLEY",
    state: "QLD",
    remarks: "",
    postcode: "4520",
    website: "https://www.samfordmowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -27.3715694466773,
    long: 152.868261370654,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "DOUGLAS MACHINERY",
    brand: "REHLKO PETROL",
    address: "34 Beech Street",
    phone: "(03) 9716 0579",
    fax: "",
    service: "KP",
    suburb: "WHITTLESEA",
    state: "VIC",
    remarks: "",
    postcode: "3757",
    website: "https://www.douglasmachinery.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.5108268615301,
    long: 145.121795408412,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "HUNTERS MOTORS & MOWERS",
    brand: "REHLKO PETROL",
    address: "25 Market Street",
    phone: "(03) 5422 1955",
    fax: "",
    service: "KP",
    suburb: "KYNETON",
    state: " VIC",
    remarks: "",
    postcode: "3444",
    website: "https://www.huntersmotors.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -37.2485363848613,
    long: 144.456314620039,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "FARM AND DIESEL",
    brand: "REHLKO PETROL|REHLKO DIESEL",
    address: "239-245 Midland Hwy",
    phone: "(03) 5432 2583",
    fax: "",
    service: "KP|KD",
    suburb: "Epsom",
    state: "VIC",
    remarks: "",
    postcode: "3551",
    website: "https://www.farmanddiesel.com.au/",
    petrol: "Yes",
    diesel: "Yes",
    lat: -35.3420608719222,
    long: 143.536050600406,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "Bendigo Mower Service",
    brand: "REHLKO PETROL",
    address: "129 Charleston Rd",
    phone: "(03) 5443 5242",
    fax: "",
    service: "KP",
    suburb: "BENDIGO",
    state: "VIC",
    remarks: "",
    postcode: "3550",
    website: "http://www.bendigomowers.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -36.7521643356716,
    long: 144.294562759984,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "MOORE MECHANICAL",
    brand: "REHLKO PETROL",
    address: "11 Hindmarsh Rd",
    phone: "(08) 8531 1622",
    fax: "",
    service: "KP",
    suburb: "Murray Bridge",
    state: "SA",
    remarks: "",
    postcode: "5253",
    website: "https://www.mooreengineering.com.au/mechanical/",
    petrol: "Yes",
    diesel: "No",
    lat: -35.1416316937639,
    long: 139.270728881344,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },   
  {
    name: "GRAHAMS SMALL MOTOR CENT",
    brand: "REHLKO PETROL",
    address: "29 Albion St",
    phone: "(08) 9821 5033",
    fax: "",
    service: "KP",
    suburb: "Katanning",
    state: "WA",
    remarks: "",
    postcode: "6317",
    website: "http://grahamssmallmotors.com/",
    petrol: "Yes",
    diesel: "No",
    lat: -33.6931308188668,
    long: 117.555368289222,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  },
  {
    name: "OLLIES MOWER SERVICE",
    brand: "REHLKO PETROL",
    address: "11 Markwell St",
    phone: "(07) 4162 4533",
    fax: "",
    service: "KP",
    suburb: "Kingaroy",
    state: "QLD",
    remarks: "",
    postcode: "4610",
    website: "https://www.olliesmowerservice.com.au/",
    petrol: "Yes",
    diesel: "No",
    lat: -26.5427745364123,
    long: 151.84010356202,
    isDieselExpert: "No",
    isPetrolExpert: "No"
  } 
];

  function populateTable(filteredDealers) {
    var selectedBrand = brandSelect.value;
    tableBody.innerHTML = "";
    // Sort dealers: experts first for selectedBrand, then non-experts for selectedBrand, then others by ascending order of distance
    filteredDealers.sort((a, b) => {
      // Check if the dealer is an expert for selectedBrand
      const isExpertForSelectedBrand =
        (selectedBrand === "REHLKO DIESEL" && a.isDieselExpert === "Yes") ||
        (selectedBrand === "REHLKO PETROL" && a.isPetrolExpert === "Yes");

      // Prioritize expert status for selectedBrand
      if (
        isExpertForSelectedBrand &&
        !(b.isDieselExpert === "Yes" || b.isPetrolExpert === "Yes")
      ) {
        return -1; // a before b
      } else if (
        !isExpertForSelectedBrand &&
        (b.isDieselExpert === "Yes" || b.isPetrolExpert === "Yes")
      ) {
        return 1; // b before a
      } else {
        // For dealers who are experts/non-experts for selectedBrand, sort by ascending order of distance
        return a.distance - b.distance;
      }
    });

    filteredDealers.forEach(function (dealer) {
      var selectedBrand = brandSelect.value;
      const brandMap = {
        "EFI SOFTWARE": "EFI",
        "REHLKO PETROL": "KP",
        "REHLKO DIESEL": "KD",
        "LOMBARDINI": "LMB",
        "LOMBARDINI MARINE": "MAR",
      };
      var selectedBranding = brandMap[selectedBrand] || "";
      var row = document.createElement("tr");
      row.innerHTML = `
      <td style="font-weight:bold;text-align:center">${dealer.name}<br>
       ${
         dealer.website
           ? `<a href="${
               dealer.website.startsWith("http://") ||
               dealer.website.startsWith("https://")
                 ? ""
                 : "https://"
             }${dealer.website}" target="_blank" class="web-link">${
               dealer.website
             }</a>`
           : ""
       } </td>
        <td style="text-align:center; line-height: 85%;">${
          dealer.address
        } <br> ${dealer.suburb} <br> ${dealer.state}  ${dealer.postcode}</td>
        <td style="text-align:center;">${dealer.distance.toFixed(2)}km</td>
        <td style="text-align:center;">${dealer.phone}</td>
        <td style="text-align:center;">${dealer.fax}</td>  
        <td style="text-align:center;">
        ${
          dealer.service.includes("EFI")
            ? '<img src="https://cdn.shopify.com/s/files/1/0797/1042/1277/files/efi-symbol-50x50-1.png?v=1691489599" alt="EFI SOFTWARE">'
            : ""
        }
        ${
          dealer.service.includes("KP")
            ? '<img src="https://cdn.shopify.com/s/files/1/0797/1042/1277/files/kohler-petrol.png?v=1691489694" alt="REHLKO PETROL">'
            : ""
        }
        ${
          dealer.service.includes("KD")
            ? '<img src="https://cdn.shopify.com/s/files/1/0797/1042/1277/files/kohler-diesel.png?v=1691489792" alt="REHLKO DIESEL">'
            : ""
        }
        ${
          dealer.service.includes("LMB")
            ? '<img src="https://cdn.shopify.com/s/files/1/0797/1042/1277/files/lombardini.png?v=1691489852" alt="LOMBARDINI">'
            : ""
        }
        ${
          dealer.service.includes("MAR")
            ? '<img src="https://cdn.shopify.com/s/files/1/0797/1042/1277/files/marine.png?v=1691489911" alt="LOMBARDINI MARINE">'
            : ""
        }
        </td>
        ${
          (selectedBrand === "REHLKO DIESEL" &&
            dealer.isDieselExpert === "Yes") ||
          (selectedBrand === "REHLKO PETROL" && dealer.isPetrolExpert === "Yes")
            ? `<td style="text-align:center;"><img src="https://cdn.shopify.com/s/files/1/0797/1042/1277/files/epg_epgines_expert.jpg?v=1695048227"></td>`
            : `<td style="text-align:center;"></td>`
        }    
      `;
      tableBody.appendChild(row);
    });
  }

  function isValidPostcode(postcode) {
    return /^\d{4}$/.test(postcode);
  }
  function updateResultCount(count) {
    resultCountElement.textContent = count;
  }
  function updateSelectedBrand(brand) {
    if (brand === "|LOMBARDINI MARINE") {
      brand = "LOMBRADINI MARINE";
    } else if (brand === "|LOMBARDINI") {
      brand = "LOMBARDINI";
    } else {
      brand;
    }
    selectedBrandElement.textContent = brand;
  }
  function updateSelectedState(state) {
    selectedStateElement.textContent = state;
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }

  function findNearestDealers(state, brand, maxDistance, postcode) {
    const location = LocationDataProvider.GetData().find(
      (w) => w.state === state && w.postalCode === parseInt(postcode, 10)
    );

    console.log(location);

    if (!location) {
      noResultsMessage.style.display = "block";
      resultsText.style.display = "none";
      table.style.display = "none";
    }
    const dealersWithDistance = dealers
      .filter(
        (w) =>
          w.brand.toLowerCase().includes(brand.toLowerCase()) ||
          w.brand.toLowerCase() === brand.toLowerCase()
      )
      .map((dealer) => {
        const distance = calculateDistance(
          location.latitude,
          location.longitude,
          dealer.lat,
          dealer.long
        );
        return { ...dealer, distance };
      })
      .filter((dealer) => dealer.distance <= maxDistance);
    return dealersWithDistance;
  }

  function filterDealer() {
    var selectedBrand = brandSelect.value;
    var selectedState = stateSelect.value;
    var selectedPostcode = postcodeInput.value;

    const brandMap = {
      "EFI SOFTWARE": "EFI",
      "REHLKO PETROL": "KP",
      "REHLKO DIESEL": "KD",
      "LOMBARDINI": "LMB",
      "LOMBARDINI MARINE": "MAR",
    };
    const brandCode = brandMap[selectedBrand] || "";

    //   const coordinates = getCoordinatesForPostcode(selectedPostcode);
    //   console.log(coordinates);

    var selectedBranding = brandMap[selectedBrand] || "";
    const postcode = postcodeInput.value.trim();
    if (!isValidPostcode(postcode) && postcode != "") {
      alert("Postcode is invalid");
      return;
    }

    if (selectedBrand && selectedState && postcode) {
      const loc = findNearestDealers(
        selectedState,
        selectedBrand,
        250,
        selectedPostcode
      );
      //  const loc = findLocationsWithinRadius(selectedBrand, selectedState, selectedPostcode, radius = 50);
      console.log(loc);
      if (!loc || loc.length === 0) {
        alert("No dealer found");
        return;
      }
      const filteredDealers = dealers.filter(function (dealer) {
        // Check if the dealer's service matches the selected brand and state
        const matchesBrand =
          selectedBrand === "" || dealer.service.includes(brandCode);
        const matchesState =
          selectedState === "" || dealer.state === selectedState;
        // Parse the dealer's postcode to integer before comparison
        const dealerPostcode = parseInt(dealer.postcode);
        // Check if the dealer's location postcode matches any of the postal codes in loc
        return (
          matchesBrand &&
          matchesState &&
          loc.some((a) => parseInt(a.postalCode) === dealerPostcode)
        );
      });
      populateTable(loc);
      // Show or hide messages and table based on results
      if (loc.length > 0) {
        resultContainer.style.display = "block";
        noResultsMessage.style.display = "none";
        resultsText.style.display = "block";
        table.style.display = "table";

        updateResultCount(loc.length);
        updateSelectedBrand(selectedBrand);
        updateSelectedState(selectedState);
      } else {
        noResultsMessage.style.display = "block";
        resultsText.style.display = "none";
        table.style.display = "none";
      }
    } else {
      if (!selectedBrand) {
        alert("Please select a brand");
      } else if (!selectedState) {
        alert("Please select a state");
      } else {
        alert("Please enter a Post code");
      }
    }
  }

  // Initial population of the table
  searchButton.addEventListener("click", filterDealer);
  // populateTable(dealers);
});